import treatmentIcon1 from './Images/treatment-icon-1.png'
import treatmentIcon2 from './Images/treatment-icon-2.png'
import treatmentIcon3 from './Images/treatment-icon-3.png'
import treatmentIcon4 from './Images/treatment-icon-4.png'
import treatmentIcon5 from './Images/treatment-icon-5.png'
import treatmentIcon6 from './Images/treatment-icon-6.png'
import treatmentIcon7 from './Images/treatment-icon-7.png'
import treatmentIcon8 from './Images/treatment-icon-8.png'
import treatmentIcon9 from './Images/treatment-icon-9.png'
import treatmentIcon10 from './Images/treatment-icon-10.png'
import treatmentIcon11 from './Images/treatment-icon-11.png'
import treatmentIcon12 from './Images/treatment-icon-12.png'

import whyChooseIcon1 from './Images/why-choose-icon-1.png'
import whyChooseIcon2 from './Images/why-choose-icon-2.png'
import whyChooseIcon3 from './Images/why-choose-icon-3.png'
import whyChooseIcon4 from './Images/why-choose-icon-4.png'
import whyChooseIcon5 from './Images/why-choose-icon-5.png'
import whyChooseIcon6 from './Images/why-choose-icon-6.png'

import instaPost1 from './Images/reel-1.webp'
import instaPost2 from './Images/reel-2.webp'
import instaPost3 from './Images/reel-3.webp'
import instaPost4 from './Images/reel-4.webp'
import instaPost5 from './Images/reel-5.webp'

import facilityIcon1 from './Images/facility-1.png'
import facilityIcon2 from './Images/facility-2.png'
import facilityIcon3 from './Images/facility-3.png'
import facilityIcon4 from './Images/facility-4.png'
import facilityIcon5 from './Images/facility-5.png'
import facilityIcon6 from './Images/facility-6.png'
import facilityIcon7 from './Images/facility-7.png'
import facilityIcon8 from './Images/facility-8.png'
import facilityIcon9 from './Images/facility-9.png'
import facilityIcon10 from './Images/facility-10.png'

import education1 from './Images/education-1.png'
import education2 from './Images/education-2.png'
import education3 from './Images/education-3.png'
import education4 from './Images/education-4.png'

import certi1 from './Images/certificate-1.webp'
import certi2 from './Images/certificate-2.webp'
import certi3 from './Images/certificate-3.webp'

import gallery1 from './Images/gallery-1.webp'
import gallery2 from './Images/gallery-2.webp'
import gallery3 from './Images/gallery-3.webp'
import gallery4 from './Images/gallery-4.webp'
import gallery5 from './Images/gallery-5.webp'
import gallery6 from './Images/gallery-6.webp'
import gallery7 from './Images/gallery-7.webp'
import gallery8 from './Images/gallery-8.webp'
import gallery9 from './Images/gallery-9.webp'
import gallery10 from './Images/gallery-10.webp'
import gallery11 from './Images/gallery-11.webp'
import gallery12 from './Images/gallery-12.webp'
import gallery13 from './Images/gallery-13.webp'
import gallery14 from './Images/gallery-14.webp'
import gallery15 from './Images/gallery-15.webp'
import gallery16 from './Images/gallery-16.webp'
import gallery17 from './Images/gallery-17.webp'
import gallery18 from './Images/gallery-18.webp'
import gallery19 from './Images/gallery-19.webp'
import gallery20 from './Images/gallery-20.webp'
import gallery21 from './Images/gallery-21.webp'

import hairCareIntro from './Images/hair-care-intro.webp'
import hairCare1 from './Images/hair-care-1.webp'
import hairCare2 from './Images/hair-care-2-new.webp'
import hairCare3 from './Images/hair-care-3-new.webp'
import hairCare4 from './Images/hair-care-4-new.webp'
import hairCare5 from './Images/hair-care-5-new.webp'
import hairCare6 from './Images/hair-care-6-new.webp'

import skinCareIntro from './Images/skin-care-intro.webp'
import skinCare1 from './Images/skin-care-1.webp'
/*import skinCare2 from './Images/skin-care-2.webp'
import skinCare3 from './Images/skin-care-3.webp'
import skinCare5 from './Images/skin-care-5.webp'*/
import skinCare4 from './Images/skin-care-4-new.webp'
import skinCare6 from './Images/skin-care-6.webp'

import childCareIntro from './Images/child-care-intro.webp'
import childCare1 from './Images/child-care-1.webp'
import childCare2 from './Images/child-care-2-new.webp'
import childCare3 from './Images/child-care-3-new.webp'
import childCare4 from './Images/child-care-4-new.webp'
/*import childCare5 from './Images/child-care-5.webp'*/
import childCare6 from './Images/child-care-6.webp'

import digestiveCareIntro from './Images/digestive-care-intro.webp'
import digestiveCare1 from './Images/digestive-care-1.webp'
/*import digestiveCare2 from './Images/digestive-care-2.webp'
import digestiveCare3 from './Images/digestive-care-3.webp'*/
import digestiveCare4 from './Images/digestive-care-4-new.webp'
/*import digestiveCare5 from './Images/digestive-care-5.webp'*/
import digestiveCare6 from './Images/digestive-care-6.webp'

import womenCareIntro from './Images/women-care-intro.webp'
import womenCare1 from './Images/women-care-1.webp'
import womenCare2 from './Images/women-care-2.webp'
import womenCare3 from './Images/women-care-3.webp'
import womenCare4 from './Images/women-care-4-new.webp'
/*import womenCare5 from './Images/women-care-5.webp'*/
import womenCare6 from './Images/women-care-6.webp'

import respiratoryCareIntro from './Images/respiratory-care-intro.webp'
import respiratoryCare1 from './Images/respiratory-care-1.webp'
/*import respiratoryCare2 from './Images/respiratory-care-2.webp'
import respiratoryCare3 from './Images/respiratory-care-3.webp'*/
import respiratoryCare4 from './Images/respiratory-care-4-new.webp'
/*import respiratoryCare5 from './Images/respiratory-care-5.webp'*/
import respiratoryCare6 from './Images/respiratory-care-6.webp'

import lifestyleDisorderIntro from './Images/lifestyle-disorder-intro.webp'
import lifestyleDisorder1 from './Images/lifestyle-disorder-1.webp'
/*import lifestyleDisorder2 from './Images/lifestyle-disorder-2.webp'
import lifestyleDisorder3 from './Images/lifestyle-disorder-3.webp'*/
import lifestyleDisorder4 from './Images/lifestyle-disorder-4-new.webp'
/*import lifestyleDisorder5 from './Images/lifestyle-disorder-5.webp'*/
import lifestyleDisorder6 from './Images/lifestyle-disorder-6.webp'

import jointCareIntro from './Images/joint-care-intro.webp'
import jointCare1 from './Images/joint-care-1.webp'
/*import jointCare2 from './Images/joint-care-2.webp'
import jointCare3 from './Images/joint-care-3.webp'*/
import jointCare4 from './Images/bone-care-4-new.webp'
/*import jointCare5 from './Images/joint-care-5.webp'*/
import jointCare6 from './Images/joint-care-6.webp'

import infertilityIntro from './Images/infertility-intro.webp'
import infertility1 from './Images/infertility-1.webp'
/*import infertility2 from './Images/infertility-2.webp'
import infertility3 from './Images/infertility-3.webp'*/
import infertility4 from './Images/infertility-garbh-sanskar-4-new.webp'
/*import infertility5 from './Images/infertility-5.webp'*/
import infertility6 from './Images/infertility-6.webp'

import mentalWellnessIntro from './Images/mental-wellness-intro.webp'
import mentalWellness1 from './Images/mental-wellness-1.webp'
/*import mentalWellness2 from './Images/mental-wellness-2.webp'
import mentalWellness3 from './Images/mental-wellness-3.webp'*/
import mentalWellness4 from './Images/mental-wellness-4-new.webp'
/*import mentalWellness5 from './Images/mental-wellness-5.webp'*/
import mentalWellness6 from './Images/mental-wellness-6.webp'

import weightMgmtIntro from './Images/weight-mgmt-intro.webp'
import weightMgmt1 from './Images/weight-mgmt-1.webp'
/*import weightMgmt2 from './Images/weight-mgmt-2.webp'
import weightMgmt3 from './Images/weight-mgmt-3.webp'*/
import weightMgmt4 from './Images/weight-mgmt-4-new.webp'
/*import weightMgmt5 from './Images/weight-mgmt-5.webp'*/
import weightMgmt6 from './Images/weight-mgmt-6.webp'

import panchkarmaDetoxificationIntro from './Images/panchkarma-detoxification-intro.webp'
import panchkarmaDetoxification1 from './Images/panchkarma-detoxification-1.webp'
/*import panchkarmaDetoxification2 from './Images/panchkarma-detoxification-2.webp'
import panchkarmaDetoxification3 from './Images/panchkarma-detoxification-3.webp'*/
import panchkarmaDetoxification4 from './Images/panchkarma-detoxification-4-new.webp'
/*import panchkarmaDetoxification5 from './Images/panchkarma-detoxification-5.webp'*/
import panchkarmaDetoxification6 from './Images/panchkarma-detoxification-6.webp'

import hairCareBg from './Images/hair-care.webp'
import skinCareBg from './Images/skin-care.webp'
import childCareBg from './Images/child-care.webp'
import digestiveCareBg from './Images/digestive-care.webp'
import womenCareBg from './Images/women-care.webp'
import respiratoryCareBg from './Images/respiratory-care.webp'
import infertilityBg from './Images/infertility-garbh-sanskar.webp'
import lifestyleDisorderBg from './Images/lifestyle-disorder.webp'
import boneCareBg from './Images/bone-joint-care.webp'
import weightLossBg from './Images/weight-loss-management.webp'
import mentalWellnessBg from './Images/mental-wellness.webp'
import panchkarmaDetoxificationBg from './Images/panchkarma-detoxification.webp'

export const welcomePoints=[
    {
        title:"Root-Cause Diagnosis:",
        desc:"In-depth personal consultations with Dr. Jigar Gor to understand your unique lifestyle, medical history, and core imbalances."
    },
    {
        title:"Authentic Panchakarma & Detox:",
        desc:"Specialized clinical detoxification to flush out accumulated toxins (Ama), boosting metabolism and immunity."
    },
    {
        title:"Chronic Illness Management:",
        desc:"Safe, 100% natural, and highly effective therapeutic interventions for lifestyle disorders and long-term ailments."
    },
    {
        title:"Holistic Mind-Body Healing:",
        desc:"A complete wellness approach designed to restore harmony to your mind, body, and soul without any side effects."
    }
]

export const treatments=[
    {
        slug:"hair-problems",
        metaTitle:"Ayurvedic Doctor For Hair Problems Treatment in Bhuj Kutch | Dr. Jigar Gor",
        metaDesc:"Best Ayurvedic clinic in Bhuj for hair problems. Natural hair care treatments for hair fall, damaged hair & dandruff under expert Ayurvedic doctor in Kutch.",
        bgImg:hairCareBg,
        icon:treatmentIcon1,
        title:"Hair Care",
        introImg:hairCareIntro,
        introHeading:"Ayurvedic Treatment for Hair Problems",
        introDesc:"Hair problems such as hair fall, dandruff, thinning hair, scalp irritation, dryness, and premature hair loss often occur due to stress, unhealthy lifestyle, hormonal imbalance, poor nutrition, pollution, and dosha disturbances. At Dr. Jigar Gor’s Ayurveda Clinic, we provide authentic Ayurvedic treatment for hair problems with a holistic and root-cause-based healing approach. Our personalized therapies combine Panchakarma treatments, herbal medicines, scalp nourishment therapies, and customized diet & lifestyle guidance to naturally restore healthy hair growth. With expert Ayurvedic care and natural healing techniques, we help strengthen hair roots, improve scalp health, reduce excessive hair fall, control dandruff, and promote thicker, healthier, and long-lasting hair naturally without harmful chemicals or side effects.",
        introSubHeading:"Signs & Symptoms of Hair Problems",
        introPoints:[
          "Hair Fall", "Dandruff", "Scalp Irritation", "Split Ends", "Damaged Hair", "Dry Hair", "Thin Hair", "Frizzy Hair", "Itchy Scalp", "Lack of Shine"
        ],
        factorsHeading:"Causative Factors for Hair Problems",
        factorsPoints:[
          {
            title:"Heat Styling:",
            text:"Damages hair shaft, leading to breakage and split ends."
          },
           {
            title:"Chemical Treatments:",
            text:"Like coloring and perming, weaken hair structure."
          },
           {
            title:"Environmental Damage:",
            text:"Sun exposure and pollution contribute to dryness and dullness."
          },
           {
            title:"Stress & Poor Sleep:",
            text:"Can disrupt hormonal balance, leading to hair loss."
          },
           {
            title:"Poor Diet:",
            text:"Nutrient deficiencies due to poor food habits affect hair health."
          },
           {
            title:"Post Pregnancy:",
            text:"Hormonal imbalances after pregnancy cause hair fall."
          },
           {
            title:"Improper Hair Care: ",
            text:"Harsh products, frequent washing, and inadequate hydration worsen hair problems."
          },
           {
            title:"Ayurveda Dosha Imbalances:",
            text:"Vata, Pitta, and Kapha imbalances affect hair health, causing dryness, inflammation, or oiliness."
          }
        ],
        approachHeading:"Our Ayurvedic Approach",
        approachDesc:(<>We treat the root cause, not just the symptoms.<br />Our expert-driven therapies work to:</>),
        approachPoints:[
          "Nourish scalp and strengthen hair roots", 
          " Improve blood circulation for healthy growth", 
          "Balance doshas naturally", 
          "Detoxify the body for long-lasting results", 
          "Personalized diet and lifestyle guidance"
        ],
        treatmentCareHeading:"Our Ayurvedic Hair Care Treatments",
        /*treatmentCare:[
          {
            img:hairCare1,
            heading:"Shirodhara",
            text:"Calms the mind and nourishes hair roots."
          },
          {
            img:hairCare2,
            heading:"Head Massage",
            text:"Improves blood circulation and strengthens scalp."
          },
          {
            img:hairCare3,
            heading:"Herbal Hair Packs",
            text:"Nourishes scalp and reduces hair fall."
          },
          {
            img:hairCare4,
            heading:"Internal Detox",
            text:"Panchakarma therapies to detoxify the body."
          },
          {
            img:hairCare5,
            heading:"Diet & Lifestyle",
            text:"Personalized diet and lifestyle for healthy hair."
          },
          {
            img:hairCare6,
            heading:"Ayurvedic Supplements",
            text:"Natural herbs to support hair health."
          }
        ],*/
       treatmentCare: [
  {
    img: hairCare1,
    heading: "Shirodhara",
    text: "Calms the mind and nourishes hair roots."
  },
  {
    img: hairCare2,
    heading: "Nadi Pariksha",
    text: "Assesses body balance to identify underlying hair concerns."
  },
  {
    img: hairCare3,
    heading: "Prakruti Pariksha",
    text: "Identifies your natural constitution for personalized hair care."
  },
  {
    img: hairCare4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
  {
    img: hairCare6,
    heading: "Pathy-Apathy",
    text: "Personalized diet charts to support treatment and healthy hair."
  }
],
canonicalImg:"/Images/hair-care.webp"
    },
     {
        slug:"skin-problems",
        metaTitle:"Ayurvedic Doctor For Skin Problems Treatment in Bhuj Kutch | Dr. Jigar Gor",
        metaDesc:"Best Ayurvedic clinic in Bhuj for skin problems. Natural skin care treatments for Acne & Pimples, Persistent Itching under expert Ayurvedic doctor in Kutch.",
        bgImg:skinCareBg,
        icon:treatmentIcon2,
        title:"Skin Care",
        introImg:skinCareIntro,
        introHeading:"Ayurvedic Treatment for Skin Problems",
        introDesc:"Skin problems such as acne, eczema, psoriasis, pigmentation, hives, dryness, and premature aging often occur due to stress, unhealthy lifestyle, hormonal imbalance, poor nutrition, pollution, & dosha disturbances (particularly Pitta and Rakta vitiation). At Dr. Jigar Gor’s Ayurveda Clinic, we provide authentic Ayurvedic treatment for skin problems with a holistic & root-cause-based healing approach. Our personalized therapies combine Panchakarma treatments (detoxification), herbal medicines, targeted skin nourishment therapies, & customized diet & lifestyle guidance to naturally restore radiant, healthy skin. With expert Ayurvedic care & natural healing techniques, we help purify the blood, eliminate toxins, soothe inflammation, balance skin moisture, & promote clearer, glowing, and long-lasting skin health naturally without harmful chemicals.",
        introSubHeading:"Signs & Symptoms of Skin Problems",
        introPoints:[
          "Acne & Pimples", "Dark Spots", "Persistent Itching", "Uneven Skin Tone", "Skin Dryness", "Skin Redness", "Rashes & Hives", "Loss of Elasticity", 
        ],
        factorsHeading:"Causative Factors for Skin Problems",
        factorsPoints:[
          {
            title:"Dosha Imbalances:",
            text:"Disrupted Vata, Pitta, and Kapha cause dryness, inflammation, or excess oil."
          },
           {
            title:"Poor Digestion & Toxin Buildup (Ama):",
            text:"Weak digestion and poor detoxification create internal toxins that surface on the skin."
          },
           {
            title:"Improper Diet & Lifestyle:",
            text:"Incompatible foods, spicy diets, and unhealthy daily habits disrupt body equilibrium."
          },
           {
            title:"Psychological Factors:",
            text:"Stress, anxiety, and negative mental states weaken immunity and trigger flare-ups."
          },
           {
            title:"Seasonal Influences:",
            text:"Weather variations aggravate specific doshas, worsening skin conditions."
          },
           {
            title:"Impaired Circulation (Srotorodha):",
            text:"Blocked body channels hinder proper skin nourishment and cleansing."
          },
           {
            title:"Weak Immunity & Genetics:",
            text:"Low immunity and genetic factors increase susceptibility to chronic infections."
          }
        ],
        approachHeading:"Our Ayurvedic Approach",
        approachDesc:(<>We treat the root cause, not just the symptoms.<br /> Our expert-driven therapies work to:</>),
        approachPoints:[
          " Purify the blood and eliminate deep-seated toxins (Ama)", 
          "Soothe skin inflammation and calm aggravated Pitta", 
          "Balance all three doshas naturally for long-term health", 
          "Restore natural skin hydration, radiance, and barrier strength", 
          "Provide personalized diet and holistic lifestyle guidance"
        ],
        treatmentCareHeading:"Our Ayurvedic Hair Care Treatments",
        /*treatmentCare:[
          {
            img:skinCare1,
            heading:"Panchakarma",
            text:"Deep internal cleansing therapy to effectively eliminate toxins."
          },
          {
            img:skinCare2,
            heading:"Abhyanga & Udvartana",
            text:"Herbal massages that boost circulation & skin radiance."
          },
          {
            img:skinCare3,
            heading:"Lepa",
            text:"Fresh herbal treatment packs to naturally soothe inflammation."
          },
          {
            img:skinCare4,
            heading:"Mukha Lepanam",
            text:"Customized Ayurvedic facials for deep skin nourishment."
          },
          {
            img:skinCare5,
            heading:"Shaman Chikitsa",
            text:"Internal blood-purifying medicines that heal skin from within."
          },
          {
            img:skinCare6,
            heading:"Pathya-Apathya",
            text:"Personalized diet plans to optimize digestion & skin health."
          }
        ]*/
       treatmentCare:[
          {
            img:skinCare1,
            heading:"Panchakarma",
            text:"Deep internal cleansing therapy to effectively eliminate toxins."
          },
         {
    img: hairCare2,
    heading: "Nadi Pariksha",
    text: "Assesses your body’s balance to understand the root causes of skin concerns."
  },
  {
    img: hairCare3,
    heading: "Prakruti Pariksha",
    text: "Identifies your natural constitution to create personalized skin care."
  },
  {
    img: skinCare4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
          {
            img:skinCare6,
            heading:"Pathya-Apathya",
            text:"Personalized diet plans to optimize digestion & skin health."
          }
        ],
  canonicalImg:"/Images/skin-care.webp"
    },
     {
        slug:"child-care",
        metaTitle:"Ayurvedic Doctor For Child Care Treatment in Bhuj Kutch | Dr. Jigar Gor",
        metaDesc:"Best Ayurvedic clinic in Bhuj for child care. Natural child care treatments for Frequent Illness & Poor Digestion under expert Ayurvedic doctor in Kutch.",
        bgImg:childCareBg,
        icon:treatmentIcon3,
        title:"Child Care",
        introImg:childCareIntro,
        introHeading:"Ayurvedic Approach to Child Care",
        introDesc:"Pediatric health concerns such as low immunity, digestive issues, poor concentration, skin allergies, restlessness, & seasonal infections often occur due to stress, unhealthy diet, hormonal shifts, poor nutrition, pollution, and dosha disturbances. At Dr. Jigar Gor’s Ayurveda Clinic, we provide authentic Ayurvedic treatment for child care with a holistic & root-cause-based healing approach. Our personalized therapies combine gentle Panchakarma treatments, herbal formulations, brain nourishment therapies, and customized diet & lifestyle guidance to naturally restore healthy childhood development. With expert Ayurvedic care and natural healing techniques, we help strengthen immunity, improve digestive health, reduce excessive falling sick, control allergies, and promote sharper, healthier, and long-lasting vitality naturally without harmful chemicals or side effects.",
        introSubHeading:"Signs & Symptoms of Pediatric Problems",
        introPoints:[
          "Frequent Illness", "Allergies", "Restlessness", "Poor Appetite", "Low Energy", "Poor Digestion", "Low Focus", "Skin Rashes", "Sleep Issues", "Weak Immunity"
        ],
        factorsHeading:"Causative Factors for Pediatric Problems",
        factorsPoints:[
          {
            title:"Screen Time & Stress:",
            text:"Overstimulates the mind and disrupts sleep, leading to restlessness, academic pressure, and low immunity."
          },
           {
            title:"Poor Diet & Processed Foods:",
            text:"Junk food, sugar, and nutrient deficiencies weaken the body's natural digestive fire and hinder physical growth."
          },
           {
            title:"Improper Daily Routine:",
            text:"Irregular bedtimes, frequent snacking, and inadequate hydration aggravate underlying health problems."
          },
           {
            title:"Environmental Pollutants:",
            text:"Urban smog and allergens contribute directly to chronic respiratory issues."
          },
           {
            title:"Growth Spurts:",
            text:"Rapid developmental milestones after infancy naturally cause temporary physical fatigue."
          },
           {
            title:"Ayurveda Dosha Imbalances:",
            text:"Disrupted Vata, Pitta, and Kapha levels cause childhood hyperactivity, inflammation, or lethargy."
          }
        ],
        approachHeading:"Our Ayurvedic Approach",
        approachDesc:(<>We treat the root cause, not just the symptoms.<br />Our expert-driven therapies work to:</>),
        approachPoints:[
          "Nourish the mind and strengthen physical immunity", 
          "Improve blood circulation for healthy development", 
          "Balance pediatric doshas naturally", 
          "Detoxify the body for long-lasting results", 
          "Personalized pediatric diet and lifestyle guidance"
        ],
        treatmentCareHeading:"Our Ayurvedic Child Care Treatments",
        /*treatmentCare:[
          {
            img:childCare1,
            heading:"Shirodhara",
            text:"Calms the young mind and nourishes brain functions."
          },
          {
            img:childCare2,
            heading:"Abhyanga",
            text:"Improves blood circulation & strengthens muscles & bones."
          },
          {
            img:childCare3,
            heading:"Herbal Lepas",
            text:"Nourishes sensitive skin and reduces allergic reactions."
          },
          {
            img:childCare4,
            heading:"Gentle Detox",
            text:"Mild internal therapies to safely detoxify the child's body."
          },
          {
            img:childCare5,
            heading:"Diet & Lifestyle",
            text:"Personalized nutrition and daily routine for healthy growth."
          },
          {
            img:childCare6,
            heading:"Ayurvedic Supplements",
            text:"Natural herbs and boosters to support pediatric health."
          }
        ]*/
      treatmentCare:[
          {
            img:childCare1,
            heading:"Shirodhara",
            text:"Calms the young mind and nourishes brain functions."
          },
          {
    img: childCare2,
    heading: "Nadi Pariksha",
    text: "Assesses your child’s body balance to understand underlying health concerns."
  },
  {
    img: childCare3,
    heading: "Prakruti Pariksha",
    text: "Identifies your child’s natural constitution for personalized care."
  },
  {
    img: childCare4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
  {
    img: childCare6,
    heading: "Pathy-Apathy",
    text: "Personalized diet guidance to support your child’s treatment and overall well-being."
  }
        ],
  canonicalImg:"/Images/child-care.webp"
    },
     {
        slug:"digestive-problems",
        metaTitle:"Ayurvedic Treatment For Digestive Problem in Bhuj Kutch | Dr. Jigar Gor",
        metaDesc:"Best Ayurvedic clinic in Bhuj for Digestive Problem. Natural Digestive treatments for Indigestion & Abdominal Cramps under expert Ayurvedic doctor in Kutch.",
        bgImg:digestiveCareBg,
        icon:treatmentIcon4,
        title:"Digestive Care",
        introImg:digestiveCareIntro,
        introHeading:"Ayurvedic Treatment for Digestive Problems",
        introDesc:"Digestive problems such as chronic bloating, acid reflux, constipation, irritable bowel syndrome (IBS), gas, indigestion, and abdominal discomfort often occur due to stress, unhealthy lifestyle habits, hormonal imbalances, poor nutrition, environmental toxins, and internal dosha disturbances (particularly Agni impairment). At Dr. Jigar Gor’s Ayurveda Clinic, we provide authentic Ayurvedic treatment for digestive problems with a holistic and root-cause-based healing approach. Our personalized therapies combine Panchakarma treatments, targeted herbal medicines, gut-restoration therapies, and customized diet & lifestyle guidance to naturally revive your digestive fire. With expert Ayurvedic care and natural healing techniques, we help eliminate metabolic toxins (Ama), soothe gastrointestinal inflammation, balance gut flora, and promote optimal nutrient absorption and long-lasting metabolic health without harmful chemicals or dependencies.",
        introSubHeading:"Signs & Symptoms of Digestive Problems",
        introPoints:[
          "Bloating & Gas", "Constipation", "Indigestion", "Abdominal Cramps", "Acid Reflux", "Frequent Diarrhea", "Loss of Appetite", "Post-Meal Heaviness"
        ],
        factorsHeading:"Causative Factors for Digestive Problems",
        factorsPoints:[
          {
            title:"Weak Digestive Fire (Agni Mandya):",
            text:"Impaired metabolic fire fails to digest food efficiently, creating toxic Ama accumulation."
          },
           {
            title:"Poor Dietary Choices:",
            text:"Incompatible food combinations (Viruddha Ahara), overeating, and highly processed or junk food disrupt enzymes."
          },
           {
            title:"Stress & Anxiety (Manasika Bhaav):",
            text:"High stress, emotional tension, and anxiety weaken the gut-brain axis and shut down healthy digestion."
          },
           {
            title:"Inadequate Hydration:",
            text:"Insufficient fluid intake dehydrates the gastrointestinal tract, causing dryness and sluggish elimination."
          },
           {
            title:"Sedentary Lifestyle:",
            text:"A lack of physical activity slows down regular metabolism and stagnates waste materials in the intestines."
          },
           {
            title:"Dosha Imbalances:",
            text:"Misaligned Vata, Pitta, and Kapha disrupt motility, increase acidity, or create heavy, slow digestion."
          },
          {
            title:"Gut Flora Disruptions:",
            text:"Exposure to environmental pollutants, food allergies, and the overuse of synthetic medications damages healthy gut flora."
          },
          {
            title:"Chronic Gastrointestinal Issues:",
            text:"Underlying conditions like IBS, IBD, GERD, or peptic ulcers cause persistent mucosal inflammation."
          }
        ],
        approachHeading:"Our Ayurvedic Approach",
        approachDesc:(<>We treat the root cause, not just the symptoms.<br />Our expert-driven therapies work to:</>),
        approachPoints:[
          "Strengthen core Agni to optimize nutrient assimilation", 
          "Flush out deep-seated metabolic waste to clear gut channels", 
          "Harmonize Vata, Pitta, and Kapha to regulate intestinal motility", 
          "Soothe mucosal inflammation and restore a healthy microbiome", 
          "Offer customized nutrition plans (Pathya-Apathya) for long-term metabolism"
        ],
        treatmentCareHeading:"Our Ayurvedic Digestive Care Treatments",
        /*treatmentCare:[
          {
            img:digestiveCare1,
            heading:"Panchakarma",
            text:"Deep internal cleansing to eliminate toxins."
          },
          {
            img:digestiveCare2,
            heading:"Abhyangam & Sweda",
            text:"Warm abdominal therapy to relieve bloating."
          },
          {
            img:digestiveCare3,
            heading:"Udara Lepam",
            text:"Herbal pastes to soothe gastric inflammation."
          },
          {
            img:digestiveCare4,
            heading:"Basti Chikitsa",
            text:"Medicated enemas to relieve chronic constipation."
          },
          {
            img:digestiveCare5,
            heading:"Shaman Chikitsa",
            text:"Internal herbs to revive digestive fire."
          },
          {
            img:digestiveCare6,
            heading:"Pathya-Apathya",
            text:"Customized diet plans to optimize absorption."
          }
        ]*/
       treatmentCare:[
          {
            img:digestiveCare1,
            heading:"Panchakarma",
            text:"Deep internal cleansing to eliminate toxins."
          },
         {
  img: hairCare2,
  heading: "Nadi Pariksha",
  text: "Assesses body balance to understand the underlying causes of digestive concerns."
},
{
  img: hairCare3,
  heading: "Prakruti Pariksha",
  text: "Identifies your natural constitution for personalized digestive care."
},
  {
    img: digestiveCare4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
          {
            img:digestiveCare6,
            heading:"Pathy-Apathy",
            text:"Customized diet plans to optimize absorption."
          }
        ],
  canonicalImg:"/Images/digestive-care.webp"
    },
     {
        slug:"women-care",
        metaTitle:"Ayurvedic Treatment For Women care in Bhuj Kutch | Dr. Jigar Gor",
        metaDesc:"Best Ayurvedic clinic in Bhuj for Women Care. Natural women care treatments for Irregular Periods & Severe Pain under expert Ayurvedic doctor in Kutch.",
        bgImg:womenCareBg,
        icon:treatmentIcon5,
        title:"Women Care",
        introImg:womenCareIntro,
        introHeading:"Ayurvedic Treatment for Women’s Health",
        introDesc:"Gynecological problems such as irregular menstrual cycles, PCOD/PCOS, heavy bleeding, white discharge (leukorrhea), painful periods, and menopausal symptoms often occur due to stress, unhealthy lifestyle habits, hormonal imbalances, poor nutrition, environmental toxins, and internal dosha disturbances. At Dr. Jigar Gor’s Ayurveda Clinic, we provide authentic Ayurvedic treatment for women's health issues with a holistic and root-cause-based healing approach. Our personalized therapies combine Panchakarma treatments, targeted herbal medicines, reproductive tissue rejuvenation therapies, and customized diet & lifestyle guidance to naturally restore hormonal harmony. With expert Ayurvedic care and natural healing techniques, we help eliminate reproductive toxins (Ama), soothe internal pelvic inflammation, balance hormonal secretion, and promote optimal vitality and long-lasting gynecological health without harmful synthetic hormones or dependencies.",
        introSubHeading:"Signs & Symptoms of Gynecological Problems",
        introPoints:[
          "Irregular Periods", "Severe Pain", "PCOD Symptoms", "Breast Tenderness", "Menopause", "Bleeding Issues", "White Discharge", "Mood & Fatigue", "Intimate Dryness", "Fertility Care"
        ],
        factorsHeading:"Causative Factors for Women's Health Problems",
        factorsPoints:[
          {
            title:"Dosha Imbalances:",
            text:"Misaligned Vata, Pitta, and Kapha disrupt the menstrual cycle."
          },
           {
            title:"Hormonal Disturbances:",
            text:"Poor habits break the balance between hormones and tissues."
          },
           {
            title:"Toxin Accumulation (Ama):",
            text:"Accumulated digestive toxins block and infect reproductive channels."
          },
           {
            title:"Poor Nutrition:",
            text:"Inadequate diet choices deplete tissue vitality and cause fatigue."
          },
           {
            title:"Mental Stress:",
            text:"Emotional anxiety disrupts the mind-body axis, worsening mood swings."
          },
           {
            title:"Genetic Predisposition:",
            text:"Inherited traits make individuals more vulnerable to gynecological issues."
          }
        ],
        approachHeading:"Our Ayurvedic Approach",
        approachDesc:(<>We treat the root cause, not just the symptoms.<br />Our expert-driven therapies work to:</>),
        approachPoints:[
          "Regulate the endocrine system naturally using botanical remedies", 
          "Eliminate internal toxins to purify the reproductive tract", 
          "Calm Apana Vata to normalize cycles and cramping", 
          "Strengthen the uterine lining to support overall fertility", 
          "Provide mental wellness therapies to reduce emotional stress"
        ],
        treatmentCareHeading:"Our Ayurvedic Women’s Health Care Treatments",
        /*treatmentCare:[
          {
            img:womenCare1,
            heading:"Uttar Basti",
            text:"Medicated uterine oils to boost fertility."
          },
          {
            img:womenCare2,
            heading:"Yonidhavan & Varti",
            text:"Herbal vaginal rinses to clear infections."
          },
          {
            img:womenCare3,
            heading:"Basti Chikitsa",
            text:"Medicated enemas to regulate irregular periods."
          },
          {
            img:womenCare4,
            heading:"Abhyangam & Sweda",
            text:"Warm pelvic therapies to balance hormones."
          },
          {
            img:womenCare5,
            heading:"Shaman Chikitsa",
            text:"Internal botanical remedies to restore harmony."
          },
          {
            img:womenCare6,
            heading:"Pathya-Apathya",
            text:"Customized diet plans to nourish tissues."
          }
        ]*/
      treatmentCare:[
          {
            img:womenCare1,
            heading:"Uttar Basti",
            text:"Medicated uterine oils to boost fertility."
          },
          {
    img: womenCare2,
    heading: "Nadi Pariksha",
    text: "Assesses body balance to understand the underlying causes of women’s health concerns."
  },
  {
    img: womenCare3,
    heading: "Prakruti Pariksha",
    text: "Identifies your natural constitution for personalized women’s care."
  },
  {
    img: womenCare4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
          {
            img:womenCare6,
            heading:"Pathy-Apathy",
            text:"Customized diet plans to nourish tissues."
          }
        ],
  canonicalImg:"/Images/women-care.webp"
    },
     {
        slug:"respiratory-problems",
        metaTitle:"Ayurvedic Treatment For Respiratory Problems in Bhuj Kutch | Dr. Jigar Gor",
        metaDesc:"Best Ayurvedic clinic in Bhuj for Respiratory Care. Natural Respiratory treatments for Sinus Congestion & Wheezing under expert Ayurvedic doctor in Kutch.",
        bgImg:respiratoryCareBg,
        icon:treatmentIcon6,
        title:"Respiratory Care",
        introImg:respiratoryCareIntro,
        introHeading:"Ayurvedic Treatment for Respiratory Problems",
        introDesc:"Respiratory problems such as chronic coughing, allergic rhinitis, asthma, bronchitis, sinus congestion, and frequent throat infections often occur due to stress, unhealthy lifestyle habits, weakened immunity, seasonal shifts, environmental pollution, and internal dosha disturbances (particularly Kapha and Vata vitiation). At Dr. Jigar Gor’s Ayurveda Clinic, we provide authentic Ayurvedic treatment for respiratory problems with a root-cause-based approach. Our personalized therapies combine Panchakarma treatments, targeted respiratory herbal medicines, immune-modulating remedies, and customized diet & lifestyle guidance to naturally restore clear, unhindered breathing. With expert Ayurvedic care and natural healing techniques, we help eliminate respiratory metabolic toxins (Ama), soothe mucosal tract inflammation, build deep lung resilience, and promote long-lasting respiratory tract health naturally without harmful chemicals or dependencies.",
        introSubHeading:"Signs & Symptoms of Respiratory Problems",
        introPoints:[
          "Chronic Cough", "Wheezing", "Sinus Congestion", "Fatigue & Headaches", "Shortness of Breath", "Allergic Sneezing", "Throat Infections", "Weak Immunity",
        ],
        factorsHeading:"Causative Factors for Respiratory Problems",
        factorsPoints:[
          {
            title:"Dosha Imbalances:",
            text:"Misaligned Kapha and Vata plug respiratory pathways with sticky mucus and trigger airways to constrict."
          },
           {
            title:"Toxin Accumulation (Ama):",
            text:" Weak digestive fire leaves undigested metabolic waste (Ama) to circulate and clog upper breathing tracts."
          },
           {
            title:"Improper Diet:",
            text:"Consuming heavy, cold, sticky, or Kapha-aggravating foods strains digestion and fuels excessive mucus production."
          },
           {
            title:"Environmental Toxins:",
            text:"Breathing in cold, dry air, smog, heavy dust, fumes, or occupational chemicals damages fragile airways."
          },
           {
            title:"Emotional Stress:",
            text:"High anxiety and emotional tension compromise the immune system, leaving the lungs vulnerable to hyper-reactivity."
          },
           {
            title:"Poor Lifestyle Habits:",
            text:"Late-night sleeping, lack of physical rest, or sedentary routines weaken total body resilience."
          },
           {
            title:"Seasonal Shifts & Genetics:",
            text:"Inherited constitutional sensitivities easily flare up during vulnerable weather transitions (Ritu Sandhi)."
          }
        ],
        approachHeading:"Our Ayurvedic Approach",
        approachDesc:(<>We treat the root cause, not just the symptoms.<br />Our expert-driven therapies work to:</>),
        approachPoints:[
          "Liquefy and expel deeply seated Kapha (mucus) plugs from the lungs.", 
          "Restoratively balance respiratory Vata to reduce spasms, wheezing, and allergic inflammation.", 
          "Strengthen metabolic fire to clear away toxin (Ama) generation from the root.", 
          "Deliver specialized rejuvenation therapies (Rasayana) to fortify deep pulmonary tissues.", 
          "Formulate localized seasonal diet schedules (Pathya-Apathya) to build year-round environmental defense."
        ],
        treatmentCareHeading:"Our Ayurvedic Respiratory Care Treatments",
        /*treatmentCare:[
          {
            img:respiratoryCare1,
            heading:"Panchakarma",
            text:"Deep internal cleansing to flush respiratory toxins."
          },
          {
            img:respiratoryCare2,
            heading:"Nasyam",
            text:"Medicated nasal oil drops to clear sinus congestion."
          },
          {
            img:respiratoryCare3,
            heading:"Dhumapana",
            text:"Herbal therapeutic smoking to soothe bronchial linings."
          },
          {
            img:respiratoryCare4,
            heading:"Swedana & Abhyangam",
            text:"Chest massage and localized steam to liquefy mucus."
          },
          {
            img:respiratoryCare5,
            heading:"Shaman Chikitsa",
            text:"Internal botanical formulations to restore immune harmony."
          },
          {
            img:respiratoryCare6,
            heading:"Pathya-Apathya",
            text:"Tailored warm dietary strategies to protect lung vitality."
          }
        ]*/
    treatmentCare:[
          {
            img:respiratoryCare1,
            heading:"Panchakarma",
            text:"Deep internal cleansing to flush respiratory toxins."
          },
           {
    img: hairCare2,
    heading: "Nadi Pariksha",
    text: "Assesses body balance to understand the underlying causes of respiratory concerns."
  },
  {
    img: hairCare3,
    heading: "Prakruti Pariksha",
    text: "Identifies your natural constitution for personalized respiratory care."
  },
  {
    img: respiratoryCare4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
          {
            img:respiratoryCare6,
            heading:"Pathy-Apathy",
            text:"Tailored warm dietary strategies to protect lung vitality."
          }
        ],
  canonicalImg:"/Images/respiratory-care.webp"
    },
     {
        slug:"infertility-problems",
        metaTitle:"Ayurvedic Treatment for Infertility Problems | Dr. Jigar Gor",
        metaDesc:"Best Ayurvedic clinic in Bhuj for Infertility Problems. Natural Infertility Problems treatment for garbhsanskar expert Ayurvedic doctor in Kutch.",
        bgImg:infertilityBg,
        icon:treatmentIcon7,
        title:"Infertility & Garbh Sanskar",
        showSpecialSection: true,
        introImg:infertilityIntro,
        introHeading:"Ayurvedic Treatment for Infertility Problems & Garbh Sanskar",
        introDesc:"Infertility concerns—such as difficulty conceiving after a year of trying, low egg reserve, poor sperm metrics, and recurrent miscarriages—often occur due to high stress, toxic accumulations, metabolic imbalances, poor tissue nutrition, and internal dosha disturbances. In Ayurveda, conception relies on four essential pillars: the proper season/cycle (Ritu), healthy reproductive soil (Kshetra), optimal nutritional fluids (Ambu), and pristine genetic seeds (Beeja). At Dr. Jigar Gor’s Ayurveda Clinic, we provide authentic Ayurvedic treatment for male and female infertility along with comprehensive Garbh Sanskar care. Our root-cause-based therapies combine systemic detoxifications, specialized reproductive tissue purification, month-specific pregnancy tracking, and personalized lifestyle adjustments to naturally welcome a healthy, conscious child into your life.",
        introSubHeading:"Signs & Symptoms of Infertility Problems",
        introPoints:[
          "Difficulty Conceiving", "Low AMH Levels", "PCOD / PCOS", "Recurrent Miscarriages", "Low Sperm Count", "Irregular Periods", "Uterine Fibroids", "Thyroid Imbalance"
        ],
        specialHeading:"Our Ayurvedic Approach & Garbh Sanskar Program",
        specialCards:[
         {
    mainHeading: (<>Pre-Pregnancy Care <br />(Detox & Seed Purification)</>),
    points: [
      {
        title: "Sharir Shuddhi:",
        text: "Complete systemic detoxification for both husband & wife to purge deep physical impurities."
      },
      {
        title: "Bij Shuddhi:",
        text: "Specialized herbal protocols and custom therapies to maximize the quality, vitality, and genetic strength of the sperm and ovum."
      }
    ]
  },
   {
   mainHeading: (<>Care During Pregnancy <br />(9-Month Support)</>),
    points: [
      {
        title: "Month-Wise Nourishment:",
        text: "Specialized, targeted herbal supplements adapted month-by-month to feed the growing fetus and sustain the mother's strength."
      },
      {
        title: "Complication Prevention:",
        text: "Safe, natural co-therapies meant to boost pelvic flexibility and increase the probability of a smooth, complication-free delivery."
      },
        {
        title: "Mind-Body Integration:",
        text: "Structural instructions on pregnancy diets, specialized prenatal yoga, mantra chanting, and positive lifestyle choices to foster a calm, happy pregnancy ecosystem."
      }
    ]
  },
  {
    mainHeading: (<>Post-Pregnancy Care <br />(Mother & Child Recovery)</>),
    points: [
      {
        title: "Maternal Healing:",
        text: "Specific botanical formulations to stabilize natural hormone profiles, heal the womb, and rapidly boost healthy breast milk production."
      },
      {
        title: "Newborn Vitality:",
        text: "Pediatric oil massages and specialized Suvarna Prashan drops to optimize your child's organic gut digestion, neuro-development, and immunity."
      },
    ]
  },
  ],
        treatmentCareHeading:"Our Ayurvedic Infertility Treatments",
        /*treatmentCare:[
          {
            img:infertility1,
            heading:"Uttar Basti",
            text:"Medicated uterine oils to boost fertility."
          },
          {
            img:infertility2,
            heading:"Vamana Chikitsa",
            text:"Therapeutic emesis to balance reproductive hormones."
          },
          {
            img:infertility3,
            heading:"Virechana Chikitsa",
            text:"Liver purgation to flush metabolic toxins."
          },
          {
            img:infertility4,
            heading:"Basti Chikitsa",
            text:"Medicated enemas to strengthen the womb."
          },
          {
            img:infertility5,
            heading:"Shaman Chikitsa",
            text:"Internal herbs to improve seed quality."
          },
          {
            img:infertility6,
            heading:"Pathya-Apathya",
            text:"Specialized fertility diets to nourish tissues."
          }
        ]*/
      treatmentCare:[
          {
            img:infertility1,
            heading:"Uttar Basti",
            text:"Medicated uterine oils to boost fertility."
          },
           {
    img: hairCare2,
    heading: "Nadi Pariksha",
    text: "Assesses body balance to understand factors that may affect reproductive health."
  },
  {
    img: hairCare3,
    heading: "Prakruti Pariksha",
    text: "Identifies your natural constitution for personalized fertility care."
  },
  {
    img: infertility4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
          {
            img:infertility6,
            heading:"Pathy-Apathy",
            text:"Specialized fertility diets to nourish tissues."
          }
        ],
  canonicalImg:"/Images/infertility-garbh-sanskar.webp"
    },
     {
        slug:"lifestyle-disorders",
        metaTitle:"Ayurvedic Treatment For Lifestyle Disorders in Bhuj Kutch | Dr. Jigar Gor",
        metaDesc:"Best Ayurvedic clinic in Bhuj for Lifestyle Disorders. Natural Lifestyle Disorders for High Blood Pressure & Stiff Joints under expert Ayurvedic doctor in Kutch.",
        bgImg:lifestyleDisorderBg,
        icon:treatmentIcon8,
        title:"Lifestyle Disorder",
        introImg:lifestyleDisorderIntro,
        introHeading:"Ayurvedic Treatment for Lifestyle Disorders",
        introDesc:"Lifestyle disorders such as diabetes, hypertension, obesity, chronic insomnia, fatty liver, hyperacidity, and high cholesterol often occur due to stress, unhealthy lifestyle habits, poor nutrition, lack of physical activity, environmental toxins, and internal dosha disturbances (particularly Agni impairment and metabolic sluggishness). At Dr. Jigar Gor’s Ayurveda Clinic, we provide authentic Ayurvedic treatment for lifestyle disorders with a root-cause-based approach. Our personalized therapies combine Panchakarma treatments, targeted metabolic herbal medicines, cellular-rejuvenation remedies, and customized diet & lifestyle guidance to naturally restore clear, balanced metabolic functions. With expert Ayurvedic care and natural healing techniques, we help eliminate deep cellular toxins (Ama), soothe internal systemic inflammation, build organic tissue resilience, and promote long-lasting metabolic health naturally without harmful chemicals.",
        introSubHeading:"Signs & Symptoms of Lifestyle Disorders",
        introPoints:[
          "Weight Gain", "High Blood Pressure", "Chronic Insomnia", "Stiff Joints", "Sugar Imbalance", "Persistent Exhaustion", "Sluggish Metabolism", "Brain Fog",
        ],
        factorsHeading:"Causative Factors for Lifestyle Disorders",
        factorsPoints:[
          {
            title:"Dosha Imbalances:",
            text:"Misaligned Vata, Pitta, and Kapha sluggishly stagnate vital energy and disrupt regular cell functions."
          },
           {
            title:"Toxin Accumulation (Dushivisha / Ama):",
            text:"Weak metabolic fire builds up dormant, cumulative toxins that congest deep tissues over years."
          },
           {
            title:"Poor Dietary Choices:",
            text:"Overeating, junk food, and incompatible food combinations (Viruddha Ahara) disrupt natural metabolic enzymes."
          },
           {
            title:"Sedentary Routines:",
            text:"A complete lack of physical activity slows fat breakdown and stalls waste elimination."
          },
           {
            title:"Daytime Sleeping (Diwaswapna):",
            text:"Sleeping right after meals or heavy daytime napping severely triggers Kapha and blocks micro-channels."
          },
           {
            title:"Mental & Emotional Stress:",
            text:"Constant corporate tension and high anxiety damage the hormonal axis and slow digestion."
          },
           {
            title:"Overuse of Synthetic Drugs:",
            text:"Excessive chemical dependencies damage healthy intestinal lining and alter gut flora."
          }
        ],
        approachHeading:"Our Ayurvedic Approach",
        approachDesc:(<>We treat the root cause, not just the symptoms.<br />Our expert-driven therapies work to:</>),
        approachPoints:[
          "Kindle core metabolic Agni to optimize fat and glucose absorption.", 
          "Clear hidden, deep-seated Ama from bodily channels to prevent organ stagnation.", 
          "Harmonize the three humors to naturally regulate healthy blood pressure and hormone secretion.", 
          "Nourish depleted cellular structures to reverse early aging and fatigue.", 
          "Prescribe strict daily and seasonal routines (Dinacharya & Ritucharya) for long-term health."
        ],
        treatmentCareHeading:"Our Ayurvedic Lifestyle Disorders Treatments",
        /*treatmentCare:[
          {
            img:lifestyleDisorder1,
            heading:"Panchakarma",
            text:"Deep detoxification to reset cellular metabolism."
          },
          {
            img:lifestyleDisorder2,
            heading:"Udvartanam",
            text:"Herbal powder body massage to burn fat & reduce obesity."
          },
          {
            img:lifestyleDisorder3,
            heading:"Shirodhara",
            text:"Warm medicated oil streaming to calm stress & cure insomnia."
          },
          {
            img:lifestyleDisorder4,
            heading:"Swedana & Abhyangam",
            text:"Therapies to improve blood circulation & dissolve toxins."
          },
          {
            img:lifestyleDisorder5,
            heading:"Shaman Chikitsa",
            text:"Botanical extracts to regulate blood sugar and cholesterol."
          },
          {
            img:lifestyleDisorder6,
            heading:"Pathya-Apathya",
            text:"Structured dietary modifications to establish long-term health."
          }
        ]*/
    treatmentCare:[
          {
            img:lifestyleDisorder1,
            heading:"Panchakarma",
            text:"Deep detoxification to reset cellular metabolism."
          },
         {
    img: hairCare2,
    heading: "Nadi Pariksha",
    text: "Assesses body balance to identify lifestyle-related concerns."
  },
  {
    img: hairCare3,
    heading: "Prakruti Pariksha",
    text: "Identifies your natural constitution for personalized care."
  },
  {
    img: lifestyleDisorder4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
          {
            img:lifestyleDisorder6,
            heading:"Pathy-Apathy",
            text:"Structured dietary modifications to establish long-term health."
          }
        ],
  canonicalImg:"/Images/lifestyle-disorder.webp"
    },
     {
        slug:"bone-joints-muscular-problems",
        metaTitle:"Ayurvedic Treatment for Bone, Joints & Muscular Problems | Dr. Jigar Gor",
        metaDesc:"Ayurvedic clinic in Bhuj for Bone-Joints-Muscular care. Natural Bone & Joint treatment for High Heel Pain & Swelling under expert Ayurvedic doctor in Kutch.",
        bgImg:boneCareBg,
        icon:treatmentIcon9,
        title:"Bone & Joint Care",
        introImg:jointCareIntro,
        introHeading:"Ayurvedic Treatment for Bone, Joints & Muscular Problems",
        introDesc:"Bone, joint, and muscular problems such as osteoarthritis, rheumatoid arthritis, sciatica, spondylitis, disc bulging, spinal stenosis, frozen shoulder, and muscle spasms often occur due to age, trauma, physical strain, poor nutrition, environmental triggers, and internal dosha disturbances (particularly Vata vitiation and Asthi Dhatu depletion). At Dr. Jigar Gor’s Ayurveda Clinic, we provide authentic Ayurvedic treatment for musculoskeletal disorders with a root-cause-based approach. Our personalized therapies combine Panchakarma treatments, targeted joint-rejuvenating herbs, localized therapeutic oil pools, and customized diet & lifestyle guidance to naturally restore mobility and strength. With expert Ayurvedic care and natural healing techniques, we help eliminate metabolic toxins (Ama) from joints, soothe structural inflammation, rebuild joint lubrication, and promote long-lasting bone and muscle health naturally without harmful chemical painkillers or dependencies.",
        introSubHeading:"Signs & Symptoms of Bone-Joints-Muscular Problems",
        introPoints:[
          "Joint Pain", "Swelling", "Numbness", "Heel Pain", "Frozen Shoulder", "Stiffness", "Muscular Pain", "Spine Pain", "Postpartum Aches", "Altered Gait"
        ],
        factorsHeading:"Causative Factors for Bone-Joints-Muscular Problems",
        factorsPoints:[
          {
            title:"Vata Dosha Imbalance:",
            text:"Excess Vata combined with diminished Kapha causes dryness, cracking, and severe friction within joint sockets."
          },
           {
            title:"Asthi Dhatu Imbalance:",
            text:"Insufficient nourishment to bone tissues weakens skeletal architecture, accelerating degenerative conditions like osteoporosis."
          },
           {
            title:"Weak Digestive Fire (Agni):",
            text:"Poor digestion leaves behind sticky toxins (Ama) that settle into joints, fueling inflammation, gout, and rheumatoid arthritis."
          },
           {
            title:"Nerve & Disc Compression:",
            text:"Structural shifts cause herniated discs or narrow spinal channels, pinching nerves to trigger severe sciatica or stenosis."
          },
           {
            title:"Aging & Lack of Nutrition:",
            text:"Slower tissue repair combines with calcium-poor diets to weaken bones, spines, and surrounding muscles."
          },
           {
            title:"Sedentary Habits & Trauma:",
            text:"Physical inactivity weakens stabilizing muscles, while sudden impacts or old injuries permanently disrupt local Dosha flow."
          },
           {
            title:"Post-Pregnancy Strain (Sutika Sandhivat):",
            text:"Hormonal shifts and the mechanical strain of childbirth disturb Vata, inducing long-term postpartum backache."
          }
        ],
        approachHeading:"Our Ayurvedic Approach",
        approachDesc:(<>We treat the root cause, not just the symptoms.<br />Our expert-driven therapies work to:</>),
        approachPoints:[
          "Replenish diminished synovial fluid to curb structural wear, tear, and grinding.", 
          "Utilize heavy, warm, nourishing treatments to reverse dryness and ease intense pain.", 
          "Clear system-wide and localized Ama to resolve joint redness and severe swelling.", 
          "Release deep spinal spasms to free trapped nerve roots and eliminate numbness.", 
          "Fuel the core Asthi Dhatu with bioavailable nutrients to boost mineral density."
        ],
        treatmentCareHeading:"Our Ayurvedic Bone-Joints-Muscular Treatments",
        /*treatmentCare:[
          {
            img:jointCare1,
            heading:"Janu / Kati / Griva Basti",
            text:"Deep localized warm oil reservoirs to soothe joint areas."
          },
          {
            img:jointCare2,
            heading:"Patra Pinda Sweda",
            text:"Massage using hot herbal boluses to relieve spasms & pain."
          },
          {
            img:jointCare3,
            heading:"Basti Chikitsa",
            text:"Medicated enemas designed to target Vata & nourish bones."
          },
          {
            img:jointCare4,
            heading:"Abhyangam & Sweda",
            text:"Therapeutic oiling followed by steam to reduce stiffness."
          },
          {
            img:jointCare5,
            heading:"Shaman Chikitsa",
            text:"Botanical extracts to safely clear swelling & rejuvenate tissues."
          },
          {
            img:jointCare6,
            heading:"Pathya-Apathya",
            text:"Dietary modifications to naturally strengthen skeletal integrity."
          }
        ]*/
    treatmentCare:[
          {
            img:jointCare1,
            heading:"Janu / Kati / Griva Basti",
            text:"Deep localized warm oil reservoirs to soothe joint areas."
          },
          {
    img: hairCare2,
    heading: "Nadi Pariksha",
    text: "Assesses body balance to identify bone, joint and muscle concerns."
  },
  {
    img: hairCare3,
    heading: "Prakruti Pariksha",
    text: "Identifies your natural constitution for personalized joint care."
  },
  {
    img: jointCare4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
          {
            img:jointCare6,
            heading:"Pathy-Apathy",
            text:"Dietary modifications to naturally strengthen skeletal integrity."
          }
        ],
  canonicalImg:"/Images/bone-joint-care.webp"
    },
     {
        slug:"weight-management",
        metaTitle:"Ayurvedic Treatment for Weight Management | Dr. Jigar Gor",
        metaDesc:"Best Ayurvedic clinic in Bhuj for Weight Management. Natural treatment for Excessive Weight Gain, Severe Fatigue & Body Odor, expert Ayurvedic doctor in Kutch.",
        bgImg:weightLossBg,
        icon:treatmentIcon10,
        title:"Weight Loss Management",
        introImg:weightMgmtIntro,
        introHeading:"Ayurvedic Treatment for Weight Management",
        introDesc:"Weight concerns like stubborn obesity (Sthaulya), heavy abdominal fat, and slow metabolism often stem from stress, hormonal imbalances (thyroid/PCOS), poor nutrition, and a sluggish metabolic fire (Agni). At Dr. Jigar Gor’s Ayurveda Clinic, we provide authentic, root-cause-based weight management treatments. Going beyond simple calorie counting, our personalized approach combines traditional fat-burning Panchakarma, targeted metabolic herbs, holistic body-sculpting therapies, and customized diet guidance to naturally restore optimum metabolic functions. With expert care, we help eliminate deep toxins (Ama), activate natural fat breakdown, reduce fluid retention, boost vitality, and promote sustainable, long-lasting weight loss without crash diets or harmful chemicals.",
        introSubHeading:"Signs & Symptoms of Weight Management Issues",
        introPoints:[
          "Excessive Weight Gain", "Severe Fatigue", "Shortness of Breath", "Body and Joint Pain", "Sluggish Metabolism", "Body Odor", "Food Cravings", "Hormonal Weight Gain"
        ],
        factorsHeading:"Causative Factors for Weight Management Issues",
        factorsPoints:[
          {
            title:"Kapha Dosha Imbalance:",
            text:"An over-accumulation of heavy, cold, and moist Kapha elements slows down the body's natural energy expenditure."
          },
           {
            title:"Impaired Medo-Dhatu Metabolism:",
            text:"A disruption in the tissue-building process causes nutrients to convert excessively into fat tissue instead of nourishing muscles or bones."
          },
           {
            title:"Toxin Accumulation (Ama):",
            text:"Weak digestive fire leaves behind sticky, undigested metabolic toxins that block body channels and trap fat."
          },
           {
            title:"Improper Dietary Habits:",
            text:"Frequent consumption of heavy, sweet, oily, cold, or highly processed junk foods that overtax the digestive system."
          },
           {
            title:"Sedentary Lifestyle:",
            text:"A lack of physical workout and movement prevents the natural breakdown of stored fats and stalls circulation."
          },
           {
            title:"Daytime Sleeping (Diwaswapna):",
            text:"Sleeping during the day, especially immediately after meals, severely aggravates Kapha and halts metabolism."
          },
           {
            title:"Hormonal & Cortisol Stress:",
            text:"High stress triggers a rise in cortisol levels, which promotes fat deposition, fluid retention, and emotional eating."
          }
        ],
        approachHeading:"Our Ayurvedic Approach",
        approachDesc:(<>We treat the root cause, not just the symptoms.<br />Our expert-driven therapies work to:</>),
        approachPoints:[
          "Boost core digestive and cellular metabolism to ensure efficient fat burning.", 
          "Flush away deeply embedded toxic wastes (Ama) to allow unhindered nutrient and fluid movement.", 
          "Utilize specialized dry-rub treatments to break down hard, subcutaneous cellulite tissues.", 
          "Regulate metabolic hormones naturally to control insulin resistance, leptin sensitivity, and thyroid function.", 
          "Introduce easy-to-follow daily routines (Dinacharya) and mind-body balance to prevent weight relapse."
        ],
        treatmentCareHeading:"Our Ayurvedic Weight Management Treatments",
        /*treatmentCare:[
          {
            img:weightMgmt1,
            heading:"Udvartanam",
            text:"Dry herbal scrub burns cellulite."
          },
          {
            img:weightMgmt2,
            heading:"Virechana Chikitsa",
            text:"Liver purgation flushes metabolic toxins."
          },
          {
            img:weightMgmt3,
            heading:"Basti Chikitsa",
            text:"Medicated enemas clear channel blockages."
          },
          {
            img:weightMgmt4,
            heading:"Abhyangam & Sweda",
            text:"Herbal steam melts stubborn fat."
          },
          {
            img:weightMgmt5,
            heading:"Shaman Chikitsa",
            text:"Internal botanicals boost fat breakdown."
          },
          {
            img:weightMgmt6,
            heading:"Pathya-Apathya",
            text:"Light eating plans accelerate metabolism."
          }
        ]*/
    treatmentCare:[
          {
            img:weightMgmt1,
            heading:"Udvartanam",
            text:"Dry herbal scrub burns cellulite."
          },
           {
    img: hairCare2,
    heading: "Nadi Pariksha",
    text: "Assesses body balance to understand weight-related concerns."
  },
  {
    img: hairCare3,
    heading: "Prakruti Pariksha",
    text: "Identifies your natural constitution for personalized weight care."
  },
  {
    img: weightMgmt4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
          {
            img:weightMgmt6,
            heading:"Pathy-Apathy",
            text:"Light eating plans accelerate metabolism."
          }
        ],
  canonicalImg:"/Images/weight-loss-management.webp"
    },
     {
        slug:"mental-wellness",
        metaTitle:"Ayurvedic Treatment for Mental Wellness | Dr. Jigar Gor",
        metaDesc:"Best Ayurvedic clinic in Bhuj for Mental Wellness. Natural Mental Wellness treatment for Chronic Stress, Anxiety, Fear & Overthinking, expert Ayurvedic doctor in Kutch.",
        bgImg:mentalWellnessBg,
        icon:treatmentIcon11,
        title:"Mental Wellness",
        introImg:mentalWellnessIntro,
        introHeading:"Ayurvedic Treatment for Mental Wellness",
        introDesc:"Mental wellness issues like chronic stress, anxiety, migraines, and poor sleep often stem from psychological trauma, excessive screen time, and imbalanced doshas. In Ayurveda, mental peace requires balancing the physical humors and psychological attributes (Satva, Rajas, and Tamas). At Dr. Jigar Gor’s Ayurveda Clinic, we provide authentic, root-cause-based treatments for mental disorders. Our personalized therapies combine neuro-calming Panchakarma, targeted brain tonics, safe botanical remedies, mind-body integration, and lifestyle counseling to naturally restore cognitive clarity. With expert care, we help clear emotional toxins, soothe agitated nervous pathways, revive inner vitality and mental stamina (Mansik Bal), and promote long-lasting emotional health without sedative dependencies.",
        introSubHeading:"Signs & Symptoms of Mental Wellness Issues",
        introPoints:[
          "Chronic Stress", "Headaches & Migraines", "Mood Swings", "Disturbed Sleep", "Anxiety & Fear", "Cognitive Decline", "Overthinking", "Mental Fatigue"
        ],
        factorsHeading:"Causative Factors for Mental Wellness Issues",
        factorsPoints:[
          {
            title:"Mental Attribute Shift:",
            text:"High Rajas (restlessness) and Tamas (dullness) cloud mental clarity."
          },
           {
            title:"Physical Dosha Imbalance:",
            text:"Aggravated Vata triggers anxiety, while excess Pitta fuels anger."
          },
           {
            title:"Tissue Malnutrition:",
            text:"Poorly nourished nerve tissues cause cognitive weakness."
          },
           {
            title:"Chronic Stress & Trauma:",
            text:"Prolonged tension weakens emotional resilience."
          },
           {
            title:"Depleted Vitality (Ojas):",
            text:"Lowered immunity and vital essence weaken mental strength."
          },
           {
            title:"Poor Food Habits:",
            text:"Excessive stimulants and processed foods disrupt brain chemistry."
          },
           {
            title:"Lifestyle Strains:",
            text:"Overuse of digital screens and lack of activity overstimulate the mind."
          }
        ],
        approachHeading:"Our Ayurvedic Approach",
        approachDesc:(<>We treat the root cause, not just the symptoms.<br />Our expert-driven therapies work to:</>),
        approachPoints:[
          "Balance Vata to reduce racing thoughts and fear.", 
          "Use herbal protocols to boost emotional peace and patience.", 
          "Rebuild Ojas to withstand daily workplace and life stress.", 
          "Provide vital nutrients to optimize memory and focus.", 
          "Restore natural rhythms for deep, restorative sleep."
        ],
        treatmentCareHeading:"Our Ayurvedic Mental Wellness Treatments",
        /*treatmentCare:[
          {
            img:mentalWellness1,
            heading:"Shirodhara",
            text:"Medicated oil streaming on the forehead to ease stress."
          },
          {
            img:mentalWellness2,
            heading:"Nasyam",
            text:"Nasal drops to clear neural pathways & target migraines."
          },
          {
            img:mentalWellness3,
            heading:"Abhyangam & Sweda",
            text:"Warm body massage & herbal steam to lower stress."
          },
          {
            img:mentalWellness4,
            heading:"Shaman Chikitsa",
            text:"Internal brain tonics to strengthen memory."
          },
          {
            img:mentalWellness5,
            heading:"Sattvavajaya Chikitsa",
            text:"Ayurvedic counseling and meditation to stop overthinking"
          },
          {
            img:mentalWellness6,
            heading:"Pathya-Apathya",
            text:"Grounding, wholesome diets to stabilize the gut-brain axis."
          }
        ]*/
    treatmentCare:[
          {
            img:mentalWellness1,
            heading:"Shirodhara",
            text:"Medicated oil streaming on the forehead to ease stress."
          },
          {
    img: hairCare2,
    heading: "Nadi Pariksha",
    text: "Assesses body balance to understand mental wellness concerns."
  },
  {
    img: hairCare3,
    heading: "Prakruti Pariksha",
    text: "Identifies your natural constitution for personalized mental wellness."
  },
  {
    img: mentalWellness4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
          {
            img:mentalWellness6,
            heading:"Pathy-Apathy",
            text:"Grounding, wholesome diets to stabilize the gut-brain axis."
          }
        ],
  canonicalImg:"/Images/mental-wellness.webp"
    },
      {
        slug:"panchkarma-detoxification",
        metaTitle:"Ayurvedic Treatment for Panchkarma & Detoxification | Dr. Jigar Gor",
        metaDesc:"Best Ayurvedic clinic in Bhuj for Panchkarma & Detoxification. Natural treatment for Excessive Sluggish Digestion, Chronic Brain Fog & Persistent Exhaustion.",
        bgImg:panchkarmaDetoxificationBg,
        icon:treatmentIcon12,
        title:"Panchkarma Detoxification",
        introImg:panchkarmaDetoxificationIntro,
        introHeading:"Ayurvedic Panchakarma & Detoxification Care",
        introDesc:"Systemic toxicity, chronic sluggishness, and inflammatory flares often occur due to oxidative stress, environmental toxins, and deep accumulation of metabolic waste (Ama). At Dr. Jigar Gor’s Ayurveda Clinic, we provide authentic, root-cause-based Panchakarma and cellular detoxification treatments. Moving beyond surface-level cleanses, our personalized approach combines traditional purification therapies (Shodhana), cellular oiling (Snehana), and thermal channel awakening (Swedana). With expert care, we help safely pull deep-seated toxins from tissues, restore core digestive fire (Agni), revive natural cellular longevity, and promote comprehensive biological renewal without dependency on synthetic chemical laxatives.",
        introSubHeading:"Signs & Symptoms of Toxic Build-Up",
        introPoints:[
          "Sluggish Digestion", "Chronic Brain Fog", "Weight Gain", "Body Stiffness", "Persistent Exhaustion", "Coated Tongue", "Skin Disruptions", "Weak Immunity"
        ],
        factorsHeading:"Causative Factors for Cellular Toxicity",
        factorsPoints:[
          {
            title:"Impaired Digestive Fire (Manda Agni):",
            text:"Weak metabolism fails to process food, creating sticky toxins (Ama)."
          },
           {
            title:"Incompatible Food Combinations (Viruddha Ahara):",
            text:"Conflicting food items leave behind lingering molecular residue."
          },
           {
            title:"Sedentary Lifestyle Patterns:",
            text:"Lack of active movement causes lymphatic stagnation, stalling natural waste clearance."
          },
           {
            title:"Suppression of Natural Urges (Vega Dharana):",
            text:"Holding back physiological signals forces toxins backward into deep tissues."
          },
           {
            title:"Environmental & Chemical Exposure: ",
            text:"Polluted air, pesticide-laden foods, and artificial skincare burden the liver."
          },
           {
            title:"Mental & Emotional Turbulence:",
            text:"High workspace stress and anxiety create chemical imbalances that trigger digestive distress."
          },
           {
            title:"Erratic Daily Schedule:",
            text:"Late-night sleeping, skipping meals, or sleeping directly after eating slows cellular waste breakdown."
          }
        ],
        approachHeading:"Our Ayurvedic Approach",
        approachDesc:(<>We treat the root cause, not just the symptoms.<br />Our expert-driven therapies work to:</>),
        approachPoints:[
          "Use internal and external oiling (Snehana) to detach deep waste from tissues.", 
          "Channel loosened toxins toward the gastrointestinal tract using thermal heat (Swedana).", 
          "Use five traditional purification procedures (Pradhan Karma) to flush toxins out.", 
          "Regenerate efficient digestive Agni to prevent future toxin generation.", 
          "Utilize post-detox dietary restoration (Paschat Karma) to naturally scale up stamina."
        ],
        treatmentCareHeading:"Our Ayurvedic Treatmentd for Panchkarma Detoxification",
        /*treatmentCare:[
          {
            img:panchkarmaDetoxification1,
            heading:"Vamana",
            text:"Therapeutic emesis clears upper-body toxins."
          },
          {
            img:panchkarmaDetoxification2,
            heading:"Virechana",
            text:"Controlled purgation deeply purifies liver."
          },
          {
            img:panchkarmaDetoxification3,
            heading:"Basti",
            text:"Medicated enemas balance erratic Vata."
          },
          {
            img:panchkarmaDetoxification4,
            heading:"Nasya",
            text:"Nasal drops clear sinus passages."
          },
          {
            img:panchkarmaDetoxification5,
            heading:"Raktamokshana",
            text:"Targeted blood purification treats skin."
          },
          {
            img:panchkarmaDetoxification6,
            heading:"Samsarjana Krama",
            text:"Graduated eating plans restore digestion."
          }
        ]*/
    treatmentCare:[
          {
            img:panchkarmaDetoxification1,
            heading:"Vamana",
            text:"Therapeutic emesis clears upper-body toxins."
          },
                   {
    img: hairCare2,
    heading: "Nadi Pariksha",
    text: "Assesses body balance to identify underlying imbalances."
  },
  {
    img: hairCare3,
    heading: "Prakruti Pariksha",
    text: "Identifies your natural constitution for personalized detox care."
  },
  {
    img: panchkarmaDetoxification4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
          {
            img:panchkarmaDetoxification6,
            heading:"Pathy-Apathy",
            text:"Personalized diet guidance to support detoxification and recovery."
          }
        ],
  canonicalImg:"/Images/panchkarma-detoxification.webp"
    }
]

export const whyChoose=[
    {
        icon:whyChooseIcon1,
        title:"Pioneering Excellence",
        desc:"With our establishment in 2007, we’ve been at the forefront of Panchkarma treatment, setting the gold standard for comprehensive Ayurveda care in the vibrant landscape of Bhuj-Kutch."
    },
      {
        icon:whyChooseIcon2,
        title:"Expertise and Experience",
        desc:"Ayurveda Expert Dr Jigar Gor brings a wealth of experience to every treatment session, ensuring a level of care that is both meticulous and compassionate."
    },
      {
        icon:whyChooseIcon3,
        title:"Superior Medicinal Practices",
        desc:"Our commitment to Ayurveda excellence is reflected in the quality of our medicines, expertly curated by our dedicated Physician Dr. Jigar Gor to deliver maximum potency and safety to every patient."
    },
      {
        icon:whyChooseIcon4,
        title:"Precision Diagnosis",
        desc:"Through the refined art of Nadi Parikshan and Prakrutti Parikshan, we provide nuanced insights into individual health profiles, guiding the formulation of precise and tailored treatment strategies."
    },
      {
        icon:whyChooseIcon5,
        title:"Customized Care",
        desc:"Embracing the ethos of holistic wellness, each patient receives a bespoke treatment prescription, crafted with care to address their unique health needs and aspirations."
    },
      {
        icon:whyChooseIcon6,
        title:"Proven Results",
        desc:"With a distinguished track record of successful Ayurveda interventions, we pride ourselves on delivering tangible results that inspire confidence and foster enduring health and vitality."
    }
]

export const instaPosts = [
  {
    img: instaPost1,
    url: "https://www.instagram.com/dr.jigargor.ayurveda/reel/C_fiaELyW1c/",
  },
  {
    img: instaPost2,
    url: "https://www.instagram.com/dr.jigargor.ayurveda/reel/C9KORxHyw7_/",
  },
  {
    img: instaPost3,
    url: "https://www.instagram.com/dr.jigargor.ayurveda/reel/DcbVb3nBUZm/",
  },
  {
    img: instaPost4,
    url: "https://www.instagram.com/dr.jigargor.ayurveda/reel/DcRMiwloqgA/",
  },
  {
    img: instaPost5,
    url: "https://www.instagram.com/dr.jigargor.ayurveda/reel/DcJTGk0TYT-/",
  },
];

export const facilities=[
    {
        icon:facilityIcon1,
        desc:"Ayurvedic Diagnosis, Methods & Treatments"
    },
      {
        icon:facilityIcon2,
        desc:"Authentic Ayurvedic Medicines from Sanhita Granth"
    },
      {
        icon:facilityIcon3,
        desc:"Full Ayurvedic Hospital & Panchakarma Centre"
    },
      {
        icon:facilityIcon4,
        desc:"Prakrutti Body Analysis & Nadi Pariksha"
    },
      {
        icon:facilityIcon5,
        desc:"Custom Medicines per Prakrutti & Diseases"
    },
      {
        icon:facilityIcon6,
        desc:"Medical Camps, Workshops & Health Programs"
    },
      {
        icon:facilityIcon7,
        desc:"Potent Ras Aushadhi for Quick & Prompt Relief"
    },
      {
        icon:facilityIcon8,
        desc:"Panchakarma & Agni Karma Ayurvedic Therapies"
    },
      {
        icon:facilityIcon9,
        desc:"Diet & Lifestyle Planning per Individual Needs"
    },
      {
        icon:facilityIcon10,
        desc:"DinCharya, Ritucharya & Pathya Counseling"
    }
]

export const testimonials=[
    {
        title:"Janvi Gohil",
        desc:"My hands and feet were badly burned, and with the medicine given by Dr. Jigar, I got a lot of relief. I started seeing results within just 3 days. His treatment course was very helpful and effective for me.🙏🏻"
    },
    {
        title:"Manish Pal",
        desc:"Best ayurveda clinic in bhuj. Doctor suggested me best medicine. I got good results. And dr.jigar sir never suggest wrong, that helps me a lot. I'm now fully healthy with his advice and medicine. I recommend him genuinely."
    },
    {
        title:"Swami Ramdasji",
        desc:"Always provides helpful and insightful advice, both in person and over the phone at any time. He explains the properties of food and how our body responds to it in a simple and practical way. Truly supportive and reliable.”"
    },
     {
        title:"Jigar Soni",
        desc:"Great experience..within the month I felt better in scalp infection.. From the 7 to 8 years I was suffering from Scape infection and I got really nice results by the Jigar sir’s medicines."
    },
    {
        title:"Disha Das",
        desc:"I consulted Dr. JIGAR Gaur sir for skin and hair concerns, and I’m genuinely satisfied with the results.I had facial scars, and after using the prescribed scar-nil cream, I can clearly see around 20–30% improvement in 2 to 3 weeks ."
    },
    {
        title:"Nirmal Solgama",
        desc:"I had an excellent experience with Dr. Jigar Gor. His approach is very reassuring and he takes the time to listen carefully and explain the treatment clearly, which makes you feel relieved. His treatment really helped me recover faster. Thank you Sir, for your care and guidance."
    },
     {
        title:"P JOshi",
        desc:"Thank you so much Doctor Jigar, your hair treatment was effective on my hair. This is a very beneficial treatment and gives quick results. Although I have also done many other treatments but hair treatments is best for me. Once again thank you 😊"
    },
    {
        title:"Asha Devi",
        desc:"Amazing experience, i was facing dark circles and blackish shade on my face from a very long time. In just 6 months my face become very clear and clean.I am very very happy with the service and highly recommend Dr. Jigar treatment"
    },
    {
        title:"Devendra Chothani",
        desc:"The doctor examined him carefully, explained everything clearly, and gave the right treatment/medicines. Thanks to your team's efforts and good care, my son has recovered well and is now completely fine and active again."
    },
      {
        title:"Samir Dutta banik",
        desc:"I always recommend to Dr. Jigar Gor for any kind of health issues without any hesitation. Sir always guided me in a better way. His humble nature, better guidance always nourishing a patient. I'm always grateful to you Sir 🙏🙏... You are great 😃."
    },
    {
        title:"Abhilasha Rani",
        desc:"The counselling session was very helpful and insightful. Doctor Jigar was positive and supportive, and the solutions discussed were practical and easy to implement in my daily life, making the session truly valuable for my mental well-being."
    },
    {
        title:"Yashrajsinh Parmar",
        desc:"One of the best ayurveda doctor in Bhuj. I got very nice result in first 15 days. Dr.Jigar saheb is very smart and intelligent, he understands every problem of mine and gave nice medicines. I recommend Dr.Jigar Gor for authentic ayurvedic treatment in Bhuj. Thank you very much Saheb"
    }
]

export const education=[
    {
        icon:education1,
        title:"BAMS",
        desc:"Bachelor in Ayurvedic Medicine & Surgery"
    },
      {
        icon:education2,
        title:"DYA",
        desc:"Diploma in Yoga and Ayurveda"
    },
      {
        icon:education3,
        title:"PGPP",
        desc:"Post Graduate Proficiency of Panchakarma"
    },
      {
        icon:education4,
        title:"PGDEMS",
        desc:"Post Graduation Diploma in Emergency Medical Service"
    }
]

export const certificates=[
    {
        img:certi1
    },
    {
        img:certi2
    },
    {
        img:certi3
    }
]

export const gallery=[
    {
        img:gallery1
    },
    {
        img:gallery2
    },
    {
        img:gallery3
    },
    {
        img:gallery4
    },
    {
        img:gallery5
    },
    {
        img:gallery6
    },
    {
        img:gallery7
    },
    {
        img:gallery8
    },
    {
        img:gallery9
    },
    {
        img:gallery10
    },
    {
        img:gallery11
    },
    {
        img:gallery12
    },
    {
        img:gallery13
    },
    {
        img:gallery14
    },
    {
        img:gallery15
    },
    {
        img:gallery16
    },
    {
        img:gallery17
    },
    {
        img:gallery18
    },
    {
        img:gallery19
    },
    {
        img:gallery20
    },
    {
        img:gallery21
    },
]

export const prakrutiSteps = [
  {
     step: 1,
  title: "Basic Information",
  isBasicInfo: true,
  questions: []
  },

  {
    step: 2,
    title: "Body Characteristics",
   questions: [
    {
        id: "bodyFrame",
        title: "Body Frame",
        options: [
          "Thin and Lean",
          "Medium",
          "Well Built"
        ]
      },
      {
        id: "hairType",
        title: "Type of Hair",
        options: [
          "Dry and With Split Ends",
          "Normal, Thin, More Hair Fall",
          "Greasy, Heavy"
        ]
      },
      {
        id: "hairColor",
        title: "Color of Hair",
        options: [
          "Pale Brown",
          "Grey",
          "Black"
        ]
      },
      {
        id: "skin",
        title: "Skin",
        options: [
          "Dry, Rough",
          "Soft, More Sweating, Acne",
          "Moist, Greasy"
        ]
      },
      {
        id: "complexion",
        title: "Complexion",
        options: [
          "Dark, Blackish",
          "Pinkish, Shiny",
          "Glowing, White"
        ]
      },
      {
        id: "bodyWeight",
        title: "Body Weight",
        options: [
          "Low, Difficult to Put on Weight",
          "Medium, Can Easily Loss or Gain Weight",
          "Overweight, Difficult to Loss Weight"
        ]
      },
      {
        id: "nails",
        title: "Nails",
        options: [
          "Blackish, Small, Brittle",
          "Redish, Small",
          "Pinkish, Big, Smooth"
        ]
      },
      {
        id: "teeth",
        title: "Size and Color of the Teeth",
        options: [
          "Very Big or Very Small, irregular, Blackish",
          "Medium Size, Yellowish",
          "Large, Shinning White"
        ]
      },
       {
        id: "joints",
        title: "Joints",
        options: [
          "Weak, Noise on Movement",
          "Healty with Optional Strength",
          "Heavy Weight Bearing"
        ]
      },
       {
        id: "immunityPower",
        title: "Immunity Power",
        options: [
          "Poor ( Fall Sick Quickly)",
          "Moderate",
          "High ( Doesn't fall sick Frequently)"
        ]
      }
    ]
  },

  {
    step: 3,
    title: "Digestion & Appetite",
   questions: [
      {
        id: "eatingHabit",
        title: "Eating Habit",
        options: [
          "Eat Quickly Without Chewing Properly",
          "Eat at the Moderate Speed",
          "Chews Food Properly"
        ]
      },
      {
        id: "hunger",
        title: "Hunger",
        options: [
          "Irregular, Any Time",
          "Sudden Hunger Pangs, Sharp Hunger",
          "Can Skip Meal Easily"
        ]
      },
    ]
  },

  {
    step: 4,
    title: "Elimination",
    questions: [
      {
        id: "bowelMovement",
        title: "Bowel Movment",
        options: [
          "Dry, Hard, Blackish, Scanty Stools",
          "Soft, Yellowish, loose Stools",
          "Heavy, Thik, Sticky Stools"
        ]
      },
      {
        id: "sweatingPattern",
        title: "Sweating Pattern",
        options: [
          "Minimal Sweating",
          "Profusely Sweating",
          "Lesser Sweating"
        ]
      },
    ]
  },

  {
    step: 5,
    title: "Sleep & Energy",
    questions: [
      {
        id: "sleepPattern",
        title: "Sleep Pattern",
        options: [
          "Interrupted, Less",
          "Moderate",
          "Sleepy, Lazy"
        ]
      },
      {
        id: "bodyEnergy",
        title: "Body Energy",
        options: [
          "Becomes Low in Evening, Fatigues After Less Work",
          "Moderate, Gets Tired After Medium Work",
          "Excellent Eneragy Throughout Day Not Easily Fatigued"
        ]
      },
       {
        id: "bodyTemperature",
        title: "Body Temperature",
        options: [
          "Less than Normal, hands and Feet are Cold",
          "More than Normal, face and Forehead Hot",
          "Normal, Hands and Feet Slightly Cold"
        ]
      },
      {
        id: "qualityOfVoice",
        title: "Quality of Voice",
        options: [
          "Rough with Broken Words",
          "Fast Commanding",
          "Soft and Deep"
        ]
      },
    ]
  },

  {
    step: 6,
    title: "Mind & Emotions",
    questions: [
      {
        id: "mindBehaviour",
        title: "Mind Behaviour",
        options: [
          "Curious, Restless & Unorganised",
          "Logical, Aggressive & Organised",
          "Calm, Relaxed & Worry free"
        ]
      },
      {
        id: "memory",
        title: "Memory",
        options: [
          "Short Term Bad",
          "Good Memory",
          "Long Term Best"
        ]
      },
      {
        id: "reactions",
        title: "Reactions Under Adverse Situation",
        options: [
          "Anxiety, Worry, Irritability",
          "Anger, Aggression",
          "Calm, Reclusive, sometimes Depressive"
        ]
      },
      {
        id: "mood",
        title: "Mood & Temperament",
        options: [
          "Fluctuate Frequently",
          "Express Dominantly",
          "Changes Slowly"
        ]
      },
       {
        id: "nature",
        title: "Nature",
        options: [
          "Fearful, Jealous",
          "Egoistic, Fearless",
          "Forgiving, Grateful, Not Greedy"
        ]
      },
       {
        id: "negativeThoughts",
        title: "Negative Thoughts & Fear",
        options: [
          "frequently",
          "Moderate",
          "Rarely"
        ]
      },
       {
        id: "dreams",
        title: "Dreams",
        options: [
          "Sky, Wind, Flying Object and Confusion",
          "Fire, Light, Bright Colors, Violence",
          "Water Pools, Gardens and Good Relationship"
        ]
      },
       {
        id: "sensitivity",
        title: "Sensitivity",
        options: [
          "Cold, Wind & Dryness",
          "Heat, Sun & Fires",
          "Cold, Damp & Humidity"
        ]
      }
    ]
  },

  {
    step: 7,
    title: "Lifestyle",
    questions: [
      {
        id: "routine",
        title: "Routine Activities",
        options: [
          "Quick Actions, Fast Movements",
          "Planned Actions, Goal oriented",
          "Sedentary, Relaxed & Lazy"
        ]
      },
      {
        id: "weather",
        title: "Weather Conditions",
        options: [
          "Dislike Cold",
          "Dislike Heat",
          "Dislike Moist, Rainy and Cool Weather"
        ]
      },
      {
        id: "socialRelations",
        title: "Social Relations",
        options: [
          "Make Less Friends Prefers Solitude",
          "Good No. of Friends",
          "Loves to Socialize. Relationships are Long Lasting"
        ]
      },
      {
        id: "wealth",
        title: "Wealth",
        options: [
          "Spends Without Thinking Much",
          "Saves but Spends on Valuable Things",
          "Prefer More Savings"
        ]
      },
        {
        id: "communicationSkill",
        title: "Communication Skill",
        options: [
          "Fast, Irrelevant Talk, Speech not Clear",
          "Good Speaker with Geniune Argumentative Skills",
          "Authoritative, Firm and Little Speech"
        ]
      },
        {
        id: "speech",
        title: "Speech",
        options: [
          "Hoarse Voice, Very talkative",
          "Straight forward, Dominating",
          "Slow Tone, Harmonious"
        ]
      }
    ]
  },
 {
  step: 8,
  title: "Review & Results",
  isReview: true,
  questions: []
}
];

export const treatmentsGandhidham = [
 {
   slug:"hair-problems",
   metaTitle:"Ayurvedic Hair Care Treatment in Gandhidham, Kutch | Dr. Jigar Gor",
   metaDesc:"Get hair care treatment in Gandhidham, Kutch with Dr. Jigar Gor, offering Ayurvedic hair treatment for hair fall, hair problems and healthier hair.",
   bgImg:hairCareBg,
   icon:treatmentIcon1,
   title:"Hair Care",
   breadcrumbTitle:"Ayurvedic Hair Care Treatment in Gandhidham",
   introImg:hairCareIntro,
   introHeading:"Ayurvedic Treatment for Hair Problems",
   introDesc:"Hair health is closely connected with scalp condition, nutrition, daily habits, stress and overall well-being. Ayurveda takes an individualized approach to understanding these factors before recommending suitable care. At Dr. Jigar Gor’s Ayurveda, our Ayurvedic treatment for hair loss and hair-related concerns is planned according to individual requirements. The treatment approach may include Ayurvedic consultation, scalp and hair therapies, personalized medicines, dietary recommendations and lifestyle guidance. Rather than following a single routine for everyone, we focus on personalized hair care Ayurveda based on your condition and wellness goals.",
   introSubHeading:"Signs & Symptoms of Hair Problems",
   introPoints:[
    "Hair Fall", "Dandruff", "Scalp Irritation", "Split Ends", "Damaged Hair", "Dry Hair", "Thin Hair", "Frizzy Hair", "Itchy Scalp", "Lack of Shine"
   ],
   factorsHeading:"Causative Factors for Hair Problems",
   factorsPoints:[
    {
      title:"Lifestyle Factors:",
      text:"Irregular routines, inadequate rest and unhealthy daily habits may affect overall wellness and hair health."
    },
    {
      title:"Nutritional Factors:",
      text:"An imbalanced diet or inadequate nutritional intake may contribute to weak or unhealthy-looking hair."
    },
    {
      title:"Environmental Exposure:",
      text:"Dust, pollution, heat and changing environmental conditions can affect scalp and hair condition."
    },
    {
      title:"Stress & Mental Wellness:",
      text:"Ongoing stress and an imbalanced lifestyle may influence overall hair and scalp wellness."
    },
    {
      title:"Scalp Concerns:",
      text:"Excess oil, dryness, dandruff or scalp sensitivity can affect the condition of the hair."
    },
    {
      title:"Hair Care Habits:",
      text:"Excessive heat styling, harsh products and improper hair care routines may contribute to hair damage."
    },
    {
      title:"Ayurvedic Perspective: ",
      text:"Ayurveda considers individual constitution and overall balance while developing a personalized approach to hair wellness."
    },
   ],
   approachHeading:"Our Ayurvedic Approach to Hair Care",
   approachDesc:"We focus on understanding your hair and scalp concerns before recommending an individualized Ayurvedic care plan.",
   approachPoints:[
    (<><strong>Personalized assessment</strong> based on your individual health and hair concerns</>), 
    (<><strong>Ayurvedic consultation</strong> to understand lifestyle and contributing factors</>), 
    (<><strong>Scalp and hair therapies</strong> selected according to individual requirements</>), 
    (<><strong>Ayurvedic medicines</strong> when appropriate as part of the personalized plan</>), 
    (<><strong>Dietary guidance</strong> to support healthy lifestyle and hair wellness</>),
    (<><strong>Lifestyle recommendations</strong> focused on sustainable daily habits</>),
    (<><strong>Follow-up guidance</strong> to monitor your overall progress and make suitable adjustments</>)
   ],
   treatmentCareHeading:"Our Ayurvedic Hair Care Treatments",
   treatmentCare: [
    {
     img: hairCare1,
     heading: "Shirodhara",
     text: "Calms the mind and nourishes hair roots."
    },
    {
     img: hairCare2,
     heading: "Nadi Pariksha",
     text: "Assesses body balance to identify underlying hair concerns."
    },
    {
     img: hairCare3,
     heading: "Prakruti Pariksha",
     text: "Identifies your natural constitution for personalized hair care."
   },
   {
     img: hairCare4,
     heading: "Ayurvedic Diagnosis",
     text: "Personalized assessment using traditional Ayurvedic methods."
   },
   {
     img: hairCare5,
     heading: "Premium Medicines",
     text: "High-quality Ayurvedic medicines selected for your specific needs."
   },
   {
     img: hairCare6,
     heading: "Pathy-Apathy",
     text: "Personalized diet charts to support treatment and healthy hair."
   }
  ],
  ctaHeading:"Begin Your Ayurvedic Hair Care in Gandhidham",
  ctaDesc:"Take the first step toward healthier hair with Dr. Jigar Gor’s Ayurveda in Gandhidham, Kutch. Get personalized Ayurvedic care for hair fall, dandruff, dryness, thinning and other scalp concerns through traditional therapies, suitable medicines, dietary guidance and lifestyle recommendations for naturally healthy hair and scalp, based on your need.",
  canonicalImg:"/Images/hair-care.webp"
  },
  {
   slug:"skin-problems",
   metaTitle:"Ayurvedic Skin Care Treatment in Gandhidham, Kutch | Dr. Jigar Gor",
   metaDesc:"Get Ayurvedic skin care treatment in Gandhidham, Kutch with Dr. Jigar Gor for skin concerns, dry skin and personalized care at a trusted skin care clinic.",
   bgImg:skinCareBg,
   icon:treatmentIcon2,
   title:"Skin Care",
   breadcrumbTitle:"Ayurvedic Skin Care Treatment in Gandhidham",
   introImg:skinCareIntro,
   introHeading:"Ayurvedic Treatment for Skin Problems",
   introDesc:"Healthy skin is influenced by much more than external skin care. Your daily routine, dietary habits, digestion, lifestyle, stress levels, sleep patterns and individual constitution can all play a role in overall skin wellness. Ayurveda takes a holistic approach to understanding skin-related concerns by considering the individual as a whole rather than focusing only on visible symptoms. At Dr. Jigar Gor’s Ayurveda, our Ayurvedic treatment for skin diseases is planned according to individual requirements. The approach may include Ayurvedic consultation, personalized medicines, suitable therapies, dietary guidance and lifestyle recommendations. For concerns such as dry skin, acne, pigmentation or recurring skin discomfort, we focus on understanding the individual factors involved and developing a suitable Ayurvedic care plan.",
   introSubHeading:"Signs & Symptoms of Skin Problems",
   introPoints:[
    "Acne & Pimples", "Dark Spots", "Persistent Itching", "Uneven Skin Tone", "Skin Dryness", "Skin Redness", "Rashes & Hives", "Loss of Elasticity"
   ],
   factorsHeading:"Causative Factors for Skin Problems",
   factorsPoints:[
    {
      title:"Dietary Imbalance:",
      text:"Irregular eating habits and an unsuitable diet may affect digestion and overall skin wellness."
    },
    {
      title:"Poor Digestion:",
      text:"Ayurvedic care considers digestive health as an important part of maintaining healthy-looking skin."
    },
    {
      title:"Environmental Exposure:",
      text:"Dust, pollution, heat and changing weather conditions can affect the skin."
    },
    {
      title:"Lifestyle Factors:",
      text:"Irregular sleep, stress and unhealthy daily routines may influence overall skin health."
    },
    {
      title:"Skin Care Habits:",
      text:"Excessive use of unsuitable cosmetic products may contribute to dryness, irritation or sensitivity."
    },
    {
      title:"Stress & Mental Wellness: ",
      text:"Ongoing stress may affect overall well-being and can influence skin condition."
    },
    {
      title:"Seasonal Changes:",
      text:"Changes in temperature, humidity and environmental conditions can affect different skin types."
    },
   ],
   approachHeading:"Our Ayurvedic Approach to Skin Care",
   approachDesc:"We take a personalized approach to skin wellness by understanding your individual condition, lifestyle and possible contributing factors before recommending suitable care.",
   approachPoints:[
    (<>Understanding your skin concerns and individual health requirements.</>), 
    (<>Reviewing lifestyle, diet and other relevant factors.</>), 
    (<>Selecting suitable Ayurvedic therapies according to individual needs.</>), 
    (<>Recommending appropriate medicines when required as part of the care plan.</>), 
    (<>Providing practical guidance to support healthy lifestyle and skin wellness.</>),
   ],
   treatmentCareHeading:"Our Ayurvedic Skin Care Treatments",
   treatmentCare:[
    {
      img:skinCare1,
      heading:"Panchakarma",
      text:"Deep internal cleansing therapy to effectively eliminate toxins."
    },
    {
     img: hairCare2,
     heading: "Nadi Pariksha",
     text: "Assesses your body’s balance to understand the root causes of skin concerns."
   },
   {
     img: hairCare3,
     heading: "Prakruti Pariksha",
     text: "Identifies your natural constitution to create personalized skin care."
   },
   {
     img: skinCare4,
     heading: "Ayurvedic Diagnosis",
     text: "Personalized assessment using traditional Ayurvedic methods."
   },
   {
     img: hairCare5,
     heading: "Premium Medicines",
     text: "High-quality Ayurvedic medicines selected for your specific needs."
   },
   {
     img:skinCare6,
     heading:"Pathya-Apathya",
     text:"Personalized diet plans to optimize digestion & skin health."
    }
  ],
  ctaHeading:"Begin Your Ayurvedic Skin Care in Gandhidham",
  ctaDesc:"Take the first step toward healthier skin with Dr. Jigar Gor’s Ayurveda in Gandhidham, Kutch. Get personalized Ayurvedic care for dryness, acne, pigmentation and irritation through Ayurvedic therapies, suitable medicines, dietary guidance and lifestyle recommendations. Connect with our Ayurvedic skin care clinic for personalized skin care wellness.",
  canonicalImg:"/Images/skin-care.webp"
  },
 {
   slug:"child-care",
   metaTitle:"Ayurvedic Child Care Treatment in Gandhidham, Kutch | Dr. Jigar Gor",
   metaDesc:"Get child care treatment in Gandhidham, Kutch with Dr. Jigar Gor, offering Ayurvedic child wellness care focused on healthy growth and overall wellbeing.",
   bgImg:childCareBg,
   icon:treatmentIcon3,
   title:"Child Care",
   breadcrumbTitle:"Ayurvedic Child Care Treatment in Gandhidham",
   introImg:childCareIntro,
   introHeading:"Ayurvedic Child Wellness and Healthcare",
   introDesc:"Childhood is an important stage for developing healthy habits, balanced routines and overall wellness. Ayurveda takes a holistic approach by considering factors such as diet, digestion, sleep, activity, daily routine and individual constitution when understanding a child’s wellness needs. At Dr. Jigar Gor’s Ayurveda, our Ayurvedic child wellness approach is personalized according to the child's age, individual requirements and overall health. The focus is on practical guidance that parents can incorporate into everyday routines. Our care may include Ayurvedic consultation, dietary guidance, lifestyle recommendations, suitable traditional wellness therapies and personalized Ayurvedic support. The goal is to encourage healthy habits and support a child’s overall wellness naturally.",
   introSubHeading:"Signs & Symptoms of Skin Problems",
   introPoints:[
    "Frequent Illness", "Allergies", "Restlessness", "Poor Appetite", "Low Energy", "Poor Digestion", "Low Focus", "Skin Rashes", "Sleep Issues", "Weak Immunity"
   ],
   factorsHeading:"Causative Factors for Pediatric Problems",
   factorsPoints:[
    {
      title:"Digestive Health:",
      text:"Healthy digestion is an important part of maintaining energy, appetite and general well-being."
    },
    {
      title:"Sleep Routine:",
      text:" Irregular or insufficient sleep may affect a child's daily energy and routine."
    },
    {
      title:"Environmental Factors: ",
      text:"Seasonal changes, dust, pollution and changing weather may influence children's wellness."
    },
    {
      title:"Lifestyle Patterns:",
      text:"Excessive screen time, limited physical activity or irregular routines may affect healthy development."
    },
    {
      title:"Mental & Emotional Wellness:",
      text:"Stress, changes in routine and emotional factors can influence a child's overall well-being."
    },
    {
      title:"Personal Constitution:",
      text:"Ayurveda considers individual constitution when providing personalized wellness recommendations."
    },
   ],
   approachHeading:"Our Ayurvedic Approach to Child Care",
   approachDesc:"We follow a personalized approach to child wellness by understanding the child's individual needs, daily routine and overall health before providing suitable Ayurvedic guidance.",
   approachPoints:[
    "Understanding the child's wellness needs and individual requirements.", 
    "Consider diet, lifestyle, digestion, sleep and daily routine.", 
    "Providing age-appropriate suggestions to support healthy eating habits.", 
    "Encouraging balanced routines, activity, rest and healthy daily practices.", 
    "Suitable Ayurvedic therapies may be recommended according to individual needs.",
    "Personalized recommendations based on traditional Ayurvedic principles.",
    "Helping parents understand practical wellness habits that can be followed at home."
   ],
   treatmentCareHeading:"Our Ayurvedic Child Care Treatments",
   treatmentCare:[
    {
      img:childCare1,
      heading:"Shirodhara",
      text:"Calms the young mind and nourishes brain functions."
    },
    {
     img: childCare2,
     heading: "Nadi Pariksha",
     text: "Assesses your child’s body balance to understand underlying health concerns."
   },
   {
     img: childCare3,
     heading: "Prakruti Pariksha",
     text: "Identifies your child’s natural constitution for personalized care."
   },
   {
     img: childCare4,
     heading: "Ayurvedic Diagnosis",
     text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
  {
    img: childCare6,
    heading: "Pathy-Apathy",
    text: "Personalized diet guidance to support your child’s treatment and overall well-being."
  }
  ],
  ctaHeading:"Begin Your Child’s Ayurvedic Care in Gandhidham",
  ctaDesc:"Give your child personalized Ayurvedic care with Dr. Jigar Gor’s Ayurveda in Gandhidham, Kutch. Our Ayurvedic child wellness approach includes guidance for diet, digestion, sleep and daily habits. If you’re looking for Child Care treatment in Gandhidham, connect with us for personalized Ayurvedic guidance and healthy wellness support for children.",
  canonicalImg:"/Images/child-care.webp"
  },
 {
   slug:"digestive-problems",
   metaTitle:"Ayurvedic Digestive Care Treatment in Gandhidham, Kutch | Dr. Jigar Gor",
   metaDesc:"Get Ayurvedic digestive treatment in Gandhidham, Kutch with Dr. Jigar Gor for digestive problems, personalized care and better digestive health naturally.",
   bgImg:digestiveCareBg,
   icon:treatmentIcon4,
   title:"Digestive Care",
   breadcrumbTitle:"Ayurvedic Digestive Treatment in Gandhidham",
   introImg:digestiveCareIntro,
   introHeading:"Ayurvedic Treatment for Digestive Problems",
   introDesc:"Healthy digestion depends on balanced food habits, regular meal timing, lifestyle, stress levels, sleep and daily routines. Ayurveda considers these factors while understanding digestive concerns and developing a personalized wellness approach. At Dr. Jigar Gor’s Ayurveda, our Ayurvedic treatment for digestive problems is planned according to your individual condition and wellness needs. The approach may include Ayurvedic consultation, personalized medicines, suitable traditional therapies, dietary guidance and lifestyle recommendations. For concerns such as acidity, indigestion, bloating, constipation or irregular digestion, we focus on understanding possible contributing factors and creating a suitable Ayurvedic digestive health treatment plan. Our goal is to support better digestive wellness through personalized Ayurvedic care and practical lifestyle guidance in Gandhidham, Kutch.",
   introSubHeading:"Signs & Symptoms of Digestive Problems",
   introPoints:[
    "Bloating & Gas", "Constipation", "Indigestion", "Abdominal Cramps", "Acid Reflux", "Frequent Diarrhea", "Loss of Appetite", "Post-Meal Heaviness"
   ],
   factorsHeading:"Causative Factors for Digestive Problems",
   factorsPoints:[
    {
      title:"Irregular Eating Habits:",
      text:"Skipping meals, overeating or eating at inconsistent times may affect digestive comfort."
    },
    {
      title:"Dietary Choices:",
      text:"Excessively processed, heavy or unsuitable foods may influence digestion and overall wellness."
    },
    {
      title:"Poor Meal Routine:",
      text:"Eating too quickly or having irregular meal timings can affect normal digestive habits."
    },
    {
      title:"Stress & Lifestyle:",
      text:"Ongoing stress and an imbalanced daily routine may influence digestive well-being."
    },
    {
      title:"Insufficient Activity:",
      text:"Limited physical activity can affect regular daily routines and digestive wellness."
    },
    {
      title:"Inadequate Rest:",
      text:"Irregular sleep and insufficient rest may affect overall health and digestive comfort."
    },
    {
      title:"Individual Constitution:",
      text:"Ayurveda considers individual constitution and lifestyle when developing personalized digestive care."
    },
   ],
   approachHeading:"Our Ayurvedic Approach to Digestive Health",
   approachDesc:"We take a personalized approach to digestive wellness by understanding your symptoms, dietary habits, lifestyle and individual health requirements before recommending suitable care.",
   approachPoints:[
    "Understanding your digestive concerns and individual wellness needs.", 
    "Reviewing diet, meal patterns, lifestyle and relevant health factors.", 
    "Appropriate Ayurvedic medicines may be recommended according to individual requirements.", 
    "Recommendations focused on healthy daily routines, activity and rest.", 
    "Ongoing guidance to review your progress and make suitable adjustments.",
   ],
   treatmentCareHeading:"Our Ayurvedic Digestive Care Treatments",
   treatmentCare:[
    {
      img:digestiveCare1,
      heading:"Panchakarma",
      text:"Deep internal cleansing to eliminate toxins."
    },
    {
      img: hairCare2,
      heading: "Nadi Pariksha",
      text: "Assesses body balance to understand the underlying causes of digestive concerns."
    },
    {
      img: hairCare3,
      heading: "Prakruti Pariksha",
      text: "Identifies your natural constitution for personalized digestive care."
    },
    {
      img: digestiveCare4,
      heading: "Ayurvedic Diagnosis",
      text: "Personalized assessment using traditional Ayurvedic methods."
    },
    {
      img: hairCare5,
      heading: "Premium Medicines",
      text: "High-quality Ayurvedic medicines selected for your specific needs."
    },
    {
       img:digestiveCare6,
       heading:"Pathy-Apathy",
       text:"Customized diet plans to optimize absorption."
    }
  ],
  ctaHeading:"Begin Your Ayurvedic Digestive Care in Gandhidham",
  ctaDesc:"Take the first step toward better digestive wellness with Dr. Jigar Gor’s Ayurveda in Gandhidham, Kutch. Get personalized Ayurvedic digestive treatment for acidity, indigestion, bloating and constipation, with consultation, dietary guidance and traditional Ayurvedic care. Begin your digestive wellness journey today.",
  canonicalImg:"/Images/digestive-care.webp"
  },
 {
   slug:"women-care",
   metaTitle:"Ayurvedic Women Care Treatment in Gandhidham, Kutch | Dr. Jigar Gor",
   metaDesc:"Get Ayurvedic women's health treatment in Gandhidham, Kutch with Dr. Jigar Gor, offering personalized Ayurvedic care for women's wellness and health.",
   bgImg:womenCareBg,
   icon:treatmentIcon5,
   title:"Women Care",
   breadcrumbTitle:"Ayurvedic Women’s Health Treatment in Gandhidham",
   introImg:womenCareIntro,
   introHeading:"Ayurvedic Treatment for Women’s Health",
   introDesc:"Women’s health is influenced by several interconnected factors, including nutrition, digestion, lifestyle, stress, sleep and individual constitution. Ayurveda takes a holistic approach to women's wellness by considering these factors when understanding individual health concerns. At Dr. Jigar Gor’s Ayurveda, our Ayurvedic women’s wellness treatment is personalized according to individual requirements. The approach may include Ayurvedic consultation, dietary guidance, lifestyle recommendations, appropriate medicines and suitable traditional therapies. Whether you are seeking support for menstrual wellness, general women’s health or lifestyle-related concerns, our approach focuses on understanding your individual needs and creating a suitable wellness plan based on Ayurvedic principles.",
   introSubHeading:"Signs & Symptoms of Gynecological Problems",
   introPoints:[
    "Irregular Periods", "Severe Pain", "PCOD Symptoms", "Breast Tenderness", "Menopause", "Bleeding Issues", "White Discharge", "Mood & Fatigue", "Intimate Dryness", "Fertility Care"
   ],
   factorsHeading:"Causative Factors for Women's Health Problems",
   factorsPoints:[
    {
      title:"Dietary Habits:",
      text:"Irregular meals or an imbalanced diet may affect digestion and overall wellness."
    },
    {
      title:"Lifestyle Changes:",
      text:"Busy schedules and inconsistent daily routines may influence energy and general well-being."
    },
    {
      title:"Stress: ",
      text:"Ongoing physical or emotional stress can affect sleep, routine and overall wellness."
    },
    {
      title:"Sleep Patterns:",
      text:"Inadequate or irregular sleep may contribute to tiredness and reduced daily energy."
    },
    {
      title:"Digestive Health:",
      text:"Digestive wellness is an important part of maintaining overall health and balance."
    },
    {
      title:"Physical Activity:",
      text:"Limited movement and an inactive lifestyle may affect general fitness and wellness."
    },
    {
      title:"Individual Constitution:",
      text:"Ayurveda considers individual constitution when developing personalized women's wellness guidance."
    },
   ],
   approachHeading:"Our Ayurvedic Approach to Women’s Wellness",
   approachDesc:"We take a personalized approach to women's wellness by understanding individual health concerns, lifestyle, dietary habits and daily routines before recommending suitable Ayurvedic care.",
   approachPoints:[
    "Understanding your individual health and wellness requirements.", 
    "Discussing lifestyle, diet, daily routine and relevant women's health concerns.", 
    "Practical recommendations to support balanced nutrition and overall wellness.", 
    "Suitable medicines may be recommended according to individual requirements.", 
    "Appropriate Ayurvedic therapies may be included as part of a personalized care plan.",
   ],
   treatmentCareHeading:"Our Ayurvedic Women’s Health Treatments",
   treatmentCare:[
    {
      img:womenCare1,
      heading:"Uttar Basti",
      text:"Medicated uterine oils to boost fertility."
    },
    {
      img: womenCare2,
      heading: "Nadi Pariksha",
      text: "Assesses body balance to understand the underlying causes of women’s health concerns."
   },
   {
     img: womenCare3,
     heading: "Prakruti Pariksha",
     text: "Identifies your natural constitution for personalized women’s care."
  },
  {
    img: womenCare4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
  {
    img:womenCare6,
    heading:"Pathy-Apathy",
    text:"Customized diet plans to nourish tissues."
  }
],
  ctaHeading:"Begin Your Ayurvedic Women’s Wellness Journey in Gandhidham",
  ctaDesc:"Take the first step toward personalized women's wellness with Dr. Jigar Gor’s Ayurveda in Gandhidham, Kutch. Whether you are looking for support with menstrual wellness, lifestyle-related concerns, digestive health, stress or general women's wellness, an Ayurvedic consultation can help understand your individual requirements and suitable care approach.",
  canonicalImg:"/Images/women-care.webp"
  },
  {
   slug:"respiratory-problems",
   metaTitle:"Ayurvedic Respiratory Care Treatment in Gandhidham, Kutch | Dr. Jigar Gor",
   metaDesc:"Get Ayurvedic respiratory treatment in Gandhidham, Kutch with Dr. Jigar Gor for breathing problems, asthma care and personalized respiratory wellness.",
   bgImg:respiratoryCareBg,
   icon:treatmentIcon6,
   title:"Respiratory Care",
   breadcrumbTitle:"Ayurvedic Respiratory Treatment in Gandhidham",
   introImg:respiratoryCareIntro,
   introHeading:"Ayurvedic Treatment for Respiratory Problems",
   introDesc:"Respiratory health can be influenced by seasonal changes, environmental exposure, lifestyle, diet, stress and daily habits. Ayurveda considers these factors when understanding respiratory concerns and creating a personalized wellness approach. At Dr. Jigar Gor’s Ayurveda, our Ayurvedic treatment for respiratory problems is planned according to individual health requirements. The approach may include Ayurvedic consultation, suitable medicines, traditional therapies, dietary guidance and lifestyle recommendations. For concerns such as recurring cough, congestion, breathing discomfort or asthma-related wellness needs, we focus on understanding individual factors and developing suitable Ayurvedic respiratory care. Our goal is to support respiratory wellness through personalized Ayurvedic guidance, healthy lifestyle practices and appropriate care in Gandhidham, Kutch, based on individual needs and consultation.",
   introSubHeading:"Signs & Symptoms of Respiratory Problems",
   introPoints:[
    "Chronic Cough", "Wheezing", "Sinus Congestion", "Fatigue & Headaches", "Shortness of Breath", "Allergic Sneezing", "Throat Infections", "Weak Immunity"
   ],
   factorsHeading:"Causative Factors for Respiratory Problems",
   factorsPoints:[
    {
      title:"Seasonal Changes:",
      text:"Changes in weather and seasonal conditions may influence respiratory comfort."
    },
    {
      title:"Environmental Exposure:",
      text:"Dust, smoke and other environmental irritants can affect respiratory wellness."
    },
    {
      title:"Lifestyle Habits:",
      text:"An irregular daily routine may influence overall health and respiratory well-being"
    },
    {
      title:"Dietary Habits:",
      text:"Food choices and eating patterns may affect overall wellness and digestive balance."
    },
    {
      title:"Stress & Sleep:",
      text:"Stress and inadequate rest can influence general health and daily energy."
    },
    {
      title:"Low Physical Activity: ",
      text:"An inactive lifestyle may affect general fitness and respiratory wellness."
    },
   ],
   approachHeading:"Our Ayurvedic Approach to Respiratory Care",
   approachDesc:"We take a personalized approach to respiratory wellness by understanding your symptoms, lifestyle requirements before recommending suitable Ayurvedic care.",
   approachPoints:[
    "Understanding your respiratory concerns and individual wellness needs.", 
    "Reviewing lifestyle, diet, daily routine and relevant health factors.", 
    "Practical recommendations to support balanced dietary and wellness habits.", 
    "Suitable medicines may be recommended according to individual requirements.", 
    "Appropriate Ayurvedic therapies may be suggested as part of personalized care.",
   ],
   treatmentCareHeading:"Our Ayurvedic Respiratory Care Treatments",
   treatmentCare:[
  {
      img:respiratoryCare1,
      heading:"Panchakarma",
      text:"Deep internal cleansing to flush respiratory toxins."
  },
  {
    img: hairCare2,
    heading: "Nadi Pariksha",
    text: "Assesses body balance to understand the underlying causes of respiratory concerns."
  },
  {
    img: hairCare3,
    heading: "Prakruti Pariksha",
    text: "Identifies your natural constitution for personalized respiratory care."
  },
  {
    img: respiratoryCare4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
  {
    img:respiratoryCare6,
    heading:"Pathy-Apathy",
    text:"Tailored warm dietary strategies to protect lung vitality."
  }
],
  ctaHeading:"Begin Your Ayurvedic Respiratory Care in Gandhidham",
  ctaDesc:"Take the first step toward personalized respiratory wellness with Dr. Jigar Gor’s Ayurveda in Gandhidham, Kutch. Whether you experience recurring cough, congestion, breathing discomfort, seasonal respiratory concerns or asthma-related wellness needs, an Ayurvedic consultation can help understand your individual requirements and suitable care approach.",
  canonicalImg:"/Images/respiratory-care.webp"
  },
  {
   slug:"infertility-problems",
   metaTitle:"Ayurvedic Infertility & Garbh Sanskar Treatment in Gandhidham, Kutch | Dr. Jigar Gor",
   metaDesc:"Explore Ayurvedic Garbh Sanskar in Gandhidham, Kutch with Dr. Jigar Gor, offering personalized Garbh Sanskar therapy and Ayurvedic care for family wellness.",
   bgImg:infertilityBg,
   icon:treatmentIcon7,
   title:"Infertility & Garbh Sanskar",
   breadcrumbTitle:"Ayurvedic Infertility & Garbh Sanskar Treatment in Gandhidham",
   introImg:infertilityIntro,
   introHeading:"Ayurvedic Infertility problems & Garbh Sanskar",
   introDesc:"Fertility wellness involves several factors, including nutrition, lifestyle, stress, sleep, reproductive health and individual constitution. Ayurveda considers these factors while understanding fertility-related concerns and planning personalized preconception guidance. At Dr. Jigar Gor’s Ayurveda, our approach to fertility wellness is based on individual consultation and traditional Ayurvedic principles. It may include suitable dietary guidance, lifestyle recommendations, Ayurvedic medicines and traditional therapies according to individual requirements. Ayurvedic garbh sanskar focuses on mindful preconception preparation and wellness practices for couples planning pregnancy. The approach is personalized and may support healthy routines, nutrition and overall well-being before conception, while supporting mindful preparation, healthy routines, balanced nutrition and overall wellness for both partners together.",
   introSubHeading:"Signs & Symptoms of Infertility Problems",
   introPoints:[
    "Difficulty Conceiving", "Low AMH Levels", "PCOD / PCOS", "Recurrent Miscarriages", "Low Sperm Count", "Irregular Periods", "Uterine Fibroids", "Thyroid Imbalance"
   ],
   showSpecialSection: true,
   specialHeading:"Our Ayurvedic Approach to Fertility & Garbh Sanskar",
        specialCards:[
         {
    mainHeading: (<>Pre-Pregnancy Care <br />(Detox & Seed Purification)</>),
    points: [
      {
        title: "Sharir Shuddhi:",
        text: "Complete systemic detoxification for both husband & wife to support the removal of accumulated impurities."
      },
      {
        title: "Bij Shuddhi:",
        text: "Specialized Ayurvedic herbal protocols and personalized therapies to support reproductive wellness and prepare the body for conception."
      }
    ]
  },
   {
   mainHeading: (<>Care During Pregnancy <br />(9-Month Support)</>),
    points: [
      {
        title: "Month-Wise Nourishment:",
        text: "Personalized nutritional and Ayurvedic guidance adapted month-by-month to support the mother’s well-being and the developing baby."
      },
      {
        title: "Pregnancy Wellness: ",
        text: "Suitable Ayurvedic care and lifestyle recommendations to support comfort, strength and overall maternal wellness during pregnancy."
      },
        {
        title: "Mind-Body Integration:",
        text: "Guidance on pregnancy-friendly diets, gentle yoga, relaxation practices and positive lifestyle habits to encourage a calm and balanced pregnancy journey."
      }
    ]
  },
  {
    mainHeading: (<>Post-Pregnancy Care <br />(Mother & Child Recovery)</>),
    points: [
      {
        title: "Maternal Healing:",
        text: "Personalized Ayurvedic care, dietary guidance and traditional therapies to support the mother’s recovery and overall post-pregnancy wellness."
      },
      {
        title: "Newborn Wellness:",
        text: "Age-appropriate Ayurvedic guidance for newborn care, including suitable traditional practices that support healthy digestion, development and overall well-being."
      },
    ]
  },
  ],
   treatmentCareHeading:"Our Ayurvedic Infertility & Garbh Sanskar Treatments",
   treatmentCare:[
  {
    img:infertility1,
    heading:"Uttar Basti",
    text:"Medicated uterine oils to boost fertility."
  },
  {
    img: hairCare2,
    heading: "Nadi Pariksha",
    text: "Assesses body balance to understand factors that may affect reproductive health."
  },
  {
    img: hairCare3,
    heading: "Prakruti Pariksha",
    text: "Identifies your natural constitution for personalized fertility care."
  },
  {
    img: infertility4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
  {
    img:infertility6,
    heading:"Pathy-Apathy",
    text:"Specialized fertility diets to nourish tissues."
  }
  ],
  ctaHeading:"Begin Your Ayurvedic Fertility & Garbh Sanskar Journey in Gandhidham",
  ctaDesc:"Begin your personalized fertility and preconception wellness journey with Dr. Jigar Gor’s Ayurveda in Gandhidham, Kutch. Explore ayurvedic garbh sanskar and personalized guidance based on your individual wellness needs, lifestyle, diet and preconception requirements. Connect with us to learn about suitable Ayurvedic care and personalized wellness guidance today.",
  canonicalImg:"/Images/infertility-garbh-sanskar.webp"
  },
  {
   slug:"lifestyle-disorders",
   metaTitle:"Ayurvedic Lifestyle disorders Treatment in Gandhidham, Kutch | Dr. Jigar Gor",
   metaDesc:"Get Ayurvedic lifestyle disorder treatment in Gandhidham, Kutch with Dr. Jigar Gor for high blood pressure, high cholesterol and personalized wellness care.",
   bgImg:lifestyleDisorderBg,
   icon:treatmentIcon8,
   title:"Lifestyle Disorder",
   breadcrumbTitle:"Ayurvedic Lifestyle Disorder Treatment in Gandhidham",
   introImg:lifestyleDisorderIntro,
   introHeading:"Ayurvedic Treatment for Lifestyle Diseases",
   introDesc:"Lifestyle-related health concerns can be influenced by diet, physical activity, stress, sleep, work patterns and daily habits. Ayurveda considers these factors when understanding individual health requirements and planning a personalized wellness approach. At Dr. Jigar Gor’s Ayurveda, our Ayurvedic treatment for lifestyle diseases is planned according to individual needs. The approach may include Ayurvedic consultation, suitable medicines, traditional therapies, dietary guidance and lifestyle recommendations. For concerns such as high blood pressure, high cholesterol, weight concerns or metabolic wellness, we focus on understanding contributing lifestyle factors and creating a suitable Ayurvedic lifestyle disorder treatment plan. Care is personalized according to consultation, health requirements and daily routine for sustainable wellness support with practical guidance and regular follow-up support.",
   introSubHeading:"Signs & Symptoms of Lifestyle Disorders",
   introPoints:[
    "Weight Gain", "High Blood Pressure", "Chronic Insomnia", "Stiff Joints", "Sugar Imbalance", "Persistent Exhaustion", "Sluggish Metabolism", "Brain Fog"
   ],
   factorsHeading:"Causative Factors for Lifestyle Disorders",
   factorsPoints:[
    {
      title:"Unbalanced Dietary Habits:",
      text:"Frequent consumption of highly processed foods, irregular meals or unsuitable food choices may affect overall wellness."
    },
    {
      title:"Sedentary Lifestyle: ",
      text:"Limited physical activity and prolonged sitting can influence weight, energy levels and metabolic wellness."
    },
    {
      title:"Chronic Stress:",
      text:"Ongoing mental or emotional stress may affect sleep, digestion and daily routines."
    },
    {
      title:"Poor Sleep Patterns:",
      text:"Irregular sleep schedules and inadequate rest can influence energy and overall well-being."
    },
    {
      title:"Excessive Screen Time:",
      text:"Long periods of screen use may contribute to reduced activity and disturbed routines."
    },
    {
      title:"Irregular Daily Routine:",
      text:"Inconsistent meal times, work schedules and lifestyle habits may affect healthy daily balance."
    },
   ],
   approachHeading:"Our Ayurvedic Approach to Lifestyle Disorders",
   approachDesc:"We consider individual health requirements, lifestyle patterns and daily habits when developing a personalized wellness approach.",
   approachPoints:[
    "Personalized Ayurvedic consultation and assessment", 
    "Understanding diet, routine, sleep and lifestyle patterns", 
    "Suitable Ayurvedic medicines according to individual needs", 
    "Dietary guidance for healthier food and meal routines", 
    "Lifestyle recommendations supporting balanced daily habits",
    "Traditional Ayurvedic therapies were considered appropriate"
   ],
   treatmentCareHeading:"Our Ayurvedic Lifestyle Disorder Treatments",
   treatmentCare:[
  {
    img:lifestyleDisorder1,
    heading:"Panchakarma",
    text:"Deep detoxification to reset cellular metabolism."
  },
  {
    img: hairCare2,
    heading: "Nadi Pariksha",
    text: "Assesses body balance to identify lifestyle-related concerns."
  },
  {
    img: hairCare3,
    heading: "Prakruti Pariksha",
    text: "Identifies your natural constitution for personalized care."
  },
  {
    img: lifestyleDisorder4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
  {
    img:lifestyleDisorder6,
    heading:"Pathy-Apathy",
    text:"Structured dietary modifications to establish long-term health."
  }
  ],
  ctaHeading:"Begin Your Ayurvedic Lifestyle Wellness Journey in Gandhidham",
  ctaDesc:"Take the first step toward personalized lifestyle wellness with Dr. Jigar Gor’s Ayurveda in Gandhidham, Kutch. Whether you seek support for weight concerns, blood pressure, cholesterol or healthy daily habits, an Ayurvedic consultation can help identify suitable care. Connect with us to begin your personalized wellness journey today.",
  canonicalImg:"/Images/lifestyle-disorder.webp"
  },
  {
   slug:"bone-joints-muscular-problems",
   metaTitle:"Ayurvedic Bone & Muscular PainTreatment in Gandhidham, Kutch | Dr. Jigar Gor",
   metaDesc:"Get Ayurvedic treatment for joint pain in Gandhidham, Kutch with Dr. Jigar Gor, offering personalized Ayurvedic bone and muscular pain care for better mobility.",
   bgImg:boneCareBg,
   icon:treatmentIcon9,
   title:"Bone & Joint Care",
   breadcrumbTitle:"Ayurvedic Bone & Joint Treatment in Gandhidham",
   introImg:jointCareIntro,
   introHeading:"Ayurvedic Treatment for Joint Pain and Muscular Problems",
   introDesc:"Bone and joint wellness can be influenced by age, physical activity, posture, previous strain, body weight, daily routines and lifestyle habits. Ayurveda considers these factors when understanding musculoskeletal concerns and planning personalized care. At Dr. Jigar Gor’s Ayurveda, our approach to joint and muscular wellness is based on individual consultation and traditional Ayurvedic principles. It may include suitable medicines, traditional therapies, dietary guidance and lifestyle recommendations according to individual requirements. For concerns such as joint stiffness, back discomfort, muscle soreness or mobility-related discomfort, we focus on understanding contributing factors and developing a suitable Ayurvedic care plan. Our personalized approach supports comfortable movement, healthy daily routines and overall musculoskeletal wellness through appropriate guidance and regular follow-up based on individual needs for long-term daily wellness.",
   introSubHeading:"Signs & Symptoms of Bone-Joints-Muscular Problems",
   introPoints:[
    "Joint Pain", "Swelling", "Numbness", "Heel Pain", "Frozen Shoulder", "Stiffness", "Muscular Pain", "Spine Pain", "Postpartum Aches", "Altered Gait"
   ],
   factorsHeading:"Causative Factors for Bone-Joints-Muscular Problems",
   factorsPoints:[
    {
      title:"Age-Related Changes:",
      text:"Natural changes associated with ageing may influence joint flexibility, muscle strength and comfortable movement."
    },
    {
      title:"Sedentary Lifestyle:",
      text:"Limited physical activity may contribute to stiffness, reduced mobility and muscular discomfort."
    },
    {
      title:"Poor Posture:",
      text:"Incorrect sitting, standing or working positions can place additional strain on muscles and joints."
    },
    {
      title:"Physical Strain:",
      text:"Repetitive movements, excessive exercise or lifting may contribute to muscular and joint discomfort."
    },
    {
      title:"Body Weight:",
      text:"Increased physical load may place additional stress on weight-bearing joints."
    },
    {
      title:"Daily Routine:",
      text:"Irregular activity, inadequate rest and unsuitable lifestyle habits may affect overall musculoskeletal wellness."
    },
   ],
   approachHeading:"Our Ayurvedic Approach to Bone & Joint Care",
   approachDesc:"We consider individual lifestyle, physical activity, dietary habits and health requirements while developing a personalized bone and joint wellness plan.",
   approachPoints:[
    "Personalized Ayurvedic consultation and assessment", 
    "Understanding lifestyle, posture and daily activity patterns", 
    "Suitable Ayurvedic medicines according to individual needs", 
    "Traditional Ayurvedic therapies where appropriate", 
    "Dietary guidance supporting overall bone and joint wellness",
    "Lifestyle recommendations for healthier daily routines"
   ],
   treatmentCareHeading:"Our Ayurvedic Bone, Joint & Muscular Treatments",
   treatmentCare:[
  {
    img:jointCare1,
    heading:"Janu / Kati / Griva Basti",
    text:"Deep localized warm oil reservoirs to soothe joint areas."
  },
  {
    img: hairCare2,
    heading: "Nadi Pariksha",
    text: "Assesses body balance to identify bone, joint and muscle concerns."
  },
  {
    img: hairCare3,
    heading: "Prakruti Pariksha",
    text: "Identifies your natural constitution for personalized joint care."
  },
  {
    img: jointCare4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
  {
    img:jointCare6,
    heading:"Pathy-Apathy",
    text:"Dietary modifications to naturally strengthen skeletal integrity."
  }
  ],
  ctaHeading:"Begin Your Ayurvedic Bone & Joint Care in Gandhidham",
  ctaDesc:"Take the first step toward bone and joint wellness with Dr. Jigar Gor’s Ayurveda in Gandhidham, Kutch. Whether you experience joint stiffness, muscular discomfort, back concerns or mobility-related discomfort, an Ayurvedic consultation can help understand your requirements. Connect with us to explore care, lifestyle guidance and wellness support.",
  canonicalImg:"/Images/bone-joint-care.webp"
  },
  {
   slug:"weight-management",
   metaTitle:"Ayurvedic Weight Loss Management in Gandhidham, Kutch | Dr. Jigar Gor",
   metaDesc:"Get Ayurvedic weight loss treatment in Gandhidham, Kutch with Dr. Jigar Gor, offering personalized weight management and Ayurvedic care for healthy weight goals.",
   bgImg:weightLossBg,
   icon:treatmentIcon10,
   title:"Weight Loss Management",
   breadcrumbTitle:"Ayurvedic Weight Loss Treatment in Gandhidham",
   introImg:weightMgmtIntro,
   introHeading:"Ayurvedic Weight Management and Wellness",
   introDesc:"Weight management can be influenced by dietary habits, physical activity, sleep, stress, digestion, work patterns and daily routines. Ayurveda considers these factors when understanding individual body needs and developing a personalized wellness approach. At Dr. Jigar Gor’s Ayurveda, our Ayurvedic weight management approach is planned according to individual requirements. The care plan may include Ayurvedic consultation, suitable medicines, traditional therapies, dietary guidance and lifestyle recommendations. For concerns related to excess weight, slow progress, irregular routines or healthy weight goals, we focus on understanding contributing factors and creating a practical Ayurveda for weight loss plan. Our guidance supports balanced eating, regular activity, healthy routines and sustainable wellness according to individual needs and consultation, with regular follow-up and adjustments based on individual progress over time.",
   introSubHeading:"Signs & Symptoms of Weight Management Issues",
   introPoints:[
    "Excessive Weight Gain", "Severe Fatigue", "Shortness of Breath", "Body and Joint Pain", "Sluggish Metabolism", "Body Odor", "Food Cravings", "Hormonal Weight Gain"
   ],
   factorsHeading:"Causative Factors for Weight Management Issues",
   factorsPoints:[
    {
      title:"Unbalanced Dietary Habits:",
      text:"Frequent intake of processed foods, irregular meals or unsuitable food choices may affect healthy weight management."
    },
    {
      title:"Sedentary Lifestyle:",
      text:"Limited physical activity can influence energy balance, metabolism and overall fitness."
    },
    {
      title:"Irregular Sleep:",
      text:"Inadequate or inconsistent sleep may affect daily energy, appetite and healthy routines."
    },
    {
      title:"Chronic Stress:",
      text:"Ongoing stress can influence eating patterns, sleep and lifestyle habits."
    },
    {
      title:"Digestive Imbalance: ",
      text:"Irregular digestion and unsuitable dietary habits may affect overall wellness."
    },
    {
      title:"Daily Routine:",
      text:"Inconsistent meal timings, work schedules and limited physical activity can make healthy weight management more challenging."
    },
   ],
   approachHeading:"Our Ayurvedic Approach to Weight Management",
   approachDesc:"We consider individual lifestyle, dietary habits, digestion, physical activity and daily routine when developing a personalized weight management plan.",
   approachPoints:[
    "Personalized Ayurvedic consultation and assessment", 
    "Understanding dietary and lifestyle patterns", 
    "Suitable Ayurvedic medicines according to individual needs", 
    "Personalized dietary and nutrition guidance", 
    "Traditional Ayurvedic therapies where appropriate",
    "Lifestyle recommendations for healthier daily routines",
    "Guidance for regular physical activity",
    "Follow-up care according to individual progress"
   ],
   treatmentCareHeading:"Our Ayurvedic Weight Management Treatments",
   treatmentCare:[
   {
     img:weightMgmt1,
     heading:"Udvartanam",
     text:"Dry herbal scrub burns cellulite."
   },
   {
    img: hairCare2,
    heading: "Nadi Pariksha",
    text: "Assesses body balance to understand weight-related concerns."
  },
  {
    img: hairCare3,
    heading: "Prakruti Pariksha",
    text: "Identifies your natural constitution for personalized weight care."
  },
  {
    img: weightMgmt4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
  {
    img:weightMgmt6,
    heading:"Pathy-Apathy",
    text:"Light eating plans accelerate metabolism."
  }
],
  ctaHeading:"Begin Your Ayurvedic Weight Management Journey in Gandhidham",
  ctaDesc:"Begin your personalized weight wellness journey with Dr. Jigar Gor’s Ayurveda in Gandhidham, Kutch. Whether you seek support for healthy weight goals, lifestyle balance or better daily habits, an Ayurvedic consultation can help understand your requirements. Connect with us to explore personalized guidance and care for your wellness.",
  canonicalImg:"/Images/weight-loss-management.webp"
  },
  {
   slug:"mental-wellness",
   metaTitle:"Ayurvedic Mental wellness Treatment in Gandhidham, Kutch | Dr. Jigar Gor",
   metaDesc:"Get Ayurvedic mental wellness treatment in Gandhidham, Kutch with Dr. Jigar Gor, offering personalized stress management and holistic Ayurvedic wellness care.",
   bgImg:mentalWellnessBg,
   icon:treatmentIcon11,
   title:"Mental Wellness",
   breadcrumbTitle:"Ayurvedic Mental Wellness Treatment in Gandhidham",
   introImg:mentalWellnessIntro,
   introHeading:"Ayurveda for Mental Wellness and Stress Management",
   introDesc:"Mental wellness can be influenced by daily stress, irregular sleep, work pressure, emotional strain, diet, lifestyle habits and lack of adequate relaxation. Ayurveda considers these factors when understanding an individual’s overall wellbeing and creating a personalized approach to care. At Dr. Jigar Gor’s Ayurveda, our Ayurvedic mental wellness treatment focuses on understanding your individual constitution, lifestyle and wellness requirements. The approach may include Ayurvedic consultation, personalized medicines, traditional therapies, relaxation practices, dietary guidance and healthy daily-routine recommendations. For people looking for Ayurveda for mental wellness, our care approach aims to support relaxation, better lifestyle balance and overall wellbeing. Ayurvedic stress management may also include suitable therapies and practical lifestyle guidance according to individual needs. Our Ayurvedic wellness treatment is planned with a focus on personalized care rather than a one-size-fits-all approach.",
   introSubHeading:"Signs & Symptoms of Mental Wellness Issues",
   introPoints:[
    "Chronic Stress", "Headaches & Migraines", "Mood Swings", "Disturbed Sleep", "Anxiety & Fear", "Cognitive Decline", "Overthinking", "Mental Fatigue"
   ],
   factorsHeading:"Causative Factors for Mental Wellness Issues",
   factorsPoints:[
    {
      title:"Chronic Stress:",
      text:"Continuous work pressure, responsibilities or emotional strain may affect relaxation and daily balance."
    },
    {
      title:"Irregular Sleep:",
      text:"Inconsistent sleeping patterns can influence energy, concentration and overall wellbeing."
    },
    {
      title:"Unbalanced Diet:",
      text:"Irregular meals and unsuitable food habits may affect physical comfort and daily routine."
    },
    {
      title:"Sedentary Lifestyle:",
      text:"Limited physical activity and prolonged screen time can contribute to lifestyle imbalance."
    },
    {
      title:"Emotional Strain: ",
      text:"Ongoing worry, personal responsibilities or difficulty relaxing may influence mental wellness."
    },
    {
      title:"Irregular Daily Routine: ",
      text:"Inconsistent meal, work, sleep and relaxation schedules can affect overall balance."
    },
    {
      title:"Lack of Relaxation:",
      text:"Limited time for rest and self-care may make it difficult to maintain a healthy routine."
    },
   ],
   approachHeading:"Our Ayurvedic Approach to Mental Wellness",
   approachDesc:"Our Ayurvedic approach focuses on understanding the individual rather than addressing mental wellness concerns through a single method.",
   approachPoints:[
    "Personalized Ayurvedic consultation", 
    "Traditional relaxation and wellness therapies", 
    "Appropriate Ayurvedic medicines", 
    "Dietary and nutrition guidance", 
    "Healthy daily-routine recommendations",
    "Sleep and relaxation guidance",
    "Lifestyle modifications for better balance",
   ],
   treatmentCareHeading:"Our Ayurvedic Mental Wellness Treatments",
   treatmentCare:[
  {
    img:mentalWellness1,
    heading:"Shirodhara",
    text:"Medicated oil streaming on the forehead to ease stress."
  },
  {
    img: hairCare2,
    heading: "Nadi Pariksha",
    text: "Assesses body balance to understand mental wellness concerns."
  },
  {
    img: hairCare3,
    heading: "Prakruti Pariksha",
    text: "Identifies your natural constitution for personalized mental wellness."
  },
  {
    img: mentalWellness4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
  {
    img:mentalWellness6,
    heading:"Pathy-Apathy",
    text:"Grounding, wholesome diets to stabilize the gut-brain axis."
  }
  ],
  ctaHeading:"Begin Your Ayurvedic Mental Wellness Journey in Gandhidham",
  ctaDesc:"Take the first step toward better mental wellness with Dr. Jigar Gor’s Ayurveda in Gandhidham, Kutch. If stress, poor sleep, mental fatigue or daily routine concerns affect your wellbeing, an Ayurvedic consultation can help understand your individual needs.",
  canonicalImg:"/Images/mental-wellness.webp"
  },
 {
   slug:"panchkarma-detoxification",
   metaTitle:"Ayurvedic Panchakarma & Detoxification in Gandhidham, Kutch | Dr. Jigar Gor",
   metaDesc:"Get Panchkarma treatment in Gandhidham, Kutch with Dr. Jigar Gor, offering Ayurvedic Panchkarma therapy and personalized detoxification care for wellness.",
   bgImg:panchkarmaDetoxificationBg,
   icon:treatmentIcon12,
   title:"Panchkarma Detoxification",
   breadcrumbTitle:"Ayurvedic Panchkarma Treatment in Gandhidham",
   introImg:panchkarmaDetoxificationIntro,
   introHeading:"Panchkarma Therapy and Ayurvedic Detoxification",
   introDesc:"Panchkarma is a classical Ayurvedic system involving a series of therapies selected according to an individual's constitution, condition and treatment requirements. Rather than using the same procedure for everyone, Ayurveda considers digestion, lifestyle, daily routine and overall health before planning therapy. At Dr. Jigar Gor’s Ayurveda, Panchkarma therapy may include suitable preparatory care, traditional Ayurvedic procedures, dietary guidance and post-therapy recommendations under professional supervision. Our Ayurvedic detoxification treatment approach is designed around individual requirements and may support digestive wellness, relaxation and healthy routines. If you are exploring an Ayurvedic detox treatment in Gandhidham, consultation helps determine which therapies may be appropriate for your needs and wellness goals.",
   introSubHeading:"Signs & Symptoms of Toxic Build-Up",
   introPoints:[
    "Sluggish Digestion", "Chronic Brain Fog", "Weight Gain", "Body Stiffness", "Persistent Exhaustion", "Coated Tongue", "Skin Disruptions", "Weak Immunity"
   ],
   factorsHeading:"Causative Factors for Cellular Toxicity",
   factorsPoints:[
    {
      title:"Irregular eating habits:",
      text:"Unbalanced meals or inconsistent meal timing may affect digestive comfort and routine."
    },
    {
      title:"Heavy or unsuitable foods: ",
      text:"Frequent consumption of foods that are difficult to digest may contribute to digestive imbalance."
    },
    {
      title:"Sedentary lifestyle:",
      text:"Limited physical activity can influence digestion, energy levels and overall wellbeing."
    },
    {
      title:"Stress and poor sleep:",
      text:"Ongoing stress and irregular sleep patterns may affect healthy daily functioning."
    },
    {
      title:"Improper daily routines: ",
      text:"Inconsistent lifestyle habits may disturb the body's natural rhythm."
    },
    {
      title:"Seasonal changes: ",
      text:"Ayurveda considers seasonal variations when planning appropriate wellness and detoxification routines."
    },
   ],
   approachHeading:"Our Ayurvedic Approach to Panchkarma & Detoxification",
   approachDesc:"Our approach begins with understanding your individual constitution, lifestyle, digestion and wellness requirements.",
   approachPoints:[
    "Personalized Ayurvedic consultation and assessment", 
    "Selection of suitable Panchkarma procedures", 
    "Preparatory care before selected therapies", 
    "Traditional Ayurvedic therapies under professional supervision", 
    "Personalized dietary and lifestyle guidance",
    "Post-therapy recommendations for maintaining healthy routines",
   ],
   treatmentCareHeading:"Our Ayurvedic Panchkarma & Detoxification Treatments",
   treatmentCare:[
  {
    img:panchkarmaDetoxification1,
    heading:"Vamana",
    text:"Therapeutic emesis clears upper-body toxins."
  },
  {
    img: hairCare2,
    heading: "Nadi Pariksha",
    text: "Assesses body balance to identify underlying imbalances."
  },
  {
    img: hairCare3,
    heading: "Prakruti Pariksha",
    text: "Identifies your natural constitution for personalized detox care."
  },
  {
    img: panchkarmaDetoxification4,
    heading: "Ayurvedic Diagnosis",
    text: "Personalized assessment using traditional Ayurvedic methods."
  },
  {
    img: hairCare5,
    heading: "Premium Medicines",
    text: "High-quality Ayurvedic medicines selected for your specific needs."
  },
  {
    img:panchkarmaDetoxification6,
    heading:"Pathy-Apathy",
    text:"Personalized diet guidance to support detoxification and recovery."
  }
  ],
  ctaHeading:"Begin Your Ayurvedic Panchkarma Journey in Gandhidham",
  ctaDesc:"Take the first step toward personalized Ayurvedic wellness with Dr. Jigar Gor’s Ayurveda in Gandhidham, Kutch. Whether you are exploring Panchkarma treatment, Panchkarma therapy or an Ayurvedic detoxification treatment, consultation can help identify suitable care based on your individual needs. Connect with us to begin your personalized Ayurvedic Panchkarma journey.",
  canonicalImg:"/Images/panchkarma-detoxification.webp"
  },
]